var Bn = Object.defineProperty, Dn = Object.defineProperties;
var Hn = Object.getOwnPropertyDescriptors;
var ze = Object.getOwnPropertySymbols;
var Et = Object.prototype.hasOwnProperty, $t = Object.prototype.propertyIsEnumerable;
var ke = (e, t) => (t = Symbol[e]) ? t : Symbol.for("Symbol." + e), qn = (e) => {
  throw TypeError(e);
};
var vt = (e, t, n) => t in e ? Bn(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, T = (e, t) => {
  for (var n in t || (t = {}))
    Et.call(t, n) && vt(e, n, t[n]);
  if (ze)
    for (var n of ze(t))
      $t.call(t, n) && vt(e, n, t[n]);
  return e;
}, V = (e, t) => Dn(e, Hn(t));
var Ce = (e, t) => {
  var n = {};
  for (var s in e)
    Et.call(e, s) && t.indexOf(s) < 0 && (n[s] = e[s]);
  if (e != null && ze)
    for (var s of ze(e))
      t.indexOf(s) < 0 && $t.call(e, s) && (n[s] = e[s]);
  return n;
};
var ae = (e, t, n) => new Promise((s, r) => {
  var i = (a) => {
    try {
      c(n.next(a));
    } catch (u) {
      r(u);
    }
  }, o = (a) => {
    try {
      c(n.throw(a));
    } catch (u) {
      r(u);
    }
  }, c = (a) => a.done ? s(a.value) : Promise.resolve(a.value).then(i, o);
  c((n = n.apply(e, t)).next());
}), be = function(e, t) {
  this[0] = e, this[1] = t;
}, it = (e, t, n) => {
  var s = (o, c, a, u) => {
    try {
      var d = n[o](c), x = (c = d.value) instanceof be, S = d.done;
      Promise.resolve(x ? c[0] : c).then((R) => x ? s(o === "return" ? o : "next", c[1] ? { done: R.done, value: R.value } : R, a, u) : a({ value: R, done: S })).catch((R) => s("throw", R, a, u));
    } catch (R) {
      u(R);
    }
  }, r = (o) => i[o] = (c) => new Promise((a, u) => s(o, c, a, u)), i = {};
  return n = n.apply(e, t), i[ke("asyncIterator")] = () => i, r("next"), r("throw"), r("return"), i;
}, ot = (e) => {
  var t = e[ke("asyncIterator")], n = !1, s, r = {};
  return t == null ? (t = e[ke("iterator")](), s = (i) => r[i] = (o) => t[i](o)) : (t = t.call(e), s = (i) => r[i] = (o) => {
    if (n) {
      if (n = !1, i === "throw") throw o;
      return o;
    }
    return n = !0, {
      done: !1,
      value: new be(new Promise((c) => {
        var a = t[i](o);
        a instanceof Object || qn("Object expected"), c(a);
      }), 1)
    };
  }), r[ke("iterator")] = () => r, s("next"), "throw" in t ? s("throw") : r.throw = (i) => {
    throw i;
  }, "return" in t && s("return"), r;
}, Nt = (e, t, n) => (t = e[ke("asyncIterator")]) ? t.call(e) : (e = e[ke("iterator")](), t = {}, n = (s, r) => (r = e[s]) && (t[s] = (i) => new Promise((o, c, a) => (i = r.call(e, i), a = i.done, Promise.resolve(i.value).then((u) => o({ value: u, done: a }), c)))), n("next"), n("return"), t);
import { jsxs as O, Fragment as te, jsx as f } from "react/jsx-runtime";
import * as ue from "react";
import sn, { useRef as ee, useEffect as le, useCallback as at, useState as K } from "react";
function Vn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Re = {}, Ot;
function Wn() {
  if (Ot) return Re;
  Ot = 1;
  var e = sn;
  function t(g) {
    return g && typeof g == "object" && "default" in g ? g : { default: g };
  }
  var n = /* @__PURE__ */ t(e);
  function s(g, y) {
    for (var j = 0; j < y.length; j++) {
      var h = y[j];
      h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(g, h.key, h);
    }
  }
  function r(g, y, j) {
    return y && s(g.prototype, y), g;
  }
  var i = typeof process != "undefined" && process.env && process.env.NODE_ENV === "production", o = function(g) {
    return Object.prototype.toString.call(g) === "[object String]";
  }, c = /* @__PURE__ */ (function() {
    function g(j) {
      var h = j === void 0 ? {} : j, m = h.name, w = m === void 0 ? "stylesheet" : m, C = h.optimizeForSpeed, $ = C === void 0 ? i : C;
      a(o(w), "`name` must be a string"), this._name = w, this._deletedRulePlaceholder = "#" + w + "-deleted-rule____{}", a(typeof $ == "boolean", "`optimizeForSpeed` must be a boolean"), this._optimizeForSpeed = $, this._serverSheet = void 0, this._tags = [], this._injected = !1, this._rulesCount = 0;
      var M = typeof window != "undefined" && document.querySelector('meta[property="csp-nonce"]');
      this._nonce = M ? M.getAttribute("content") : null;
    }
    var y = g.prototype;
    return y.setOptimizeForSpeed = function(h) {
      a(typeof h == "boolean", "`setOptimizeForSpeed` accepts a boolean"), a(this._rulesCount === 0, "optimizeForSpeed cannot be when rules have already been inserted"), this.flush(), this._optimizeForSpeed = h, this.inject();
    }, y.isOptimizeForSpeed = function() {
      return this._optimizeForSpeed;
    }, y.inject = function() {
      var h = this;
      if (a(!this._injected, "sheet already injected"), this._injected = !0, typeof window != "undefined" && this._optimizeForSpeed) {
        this._tags[0] = this.makeStyleTag(this._name), this._optimizeForSpeed = "insertRule" in this.getSheet(), this._optimizeForSpeed || (i || console.warn("StyleSheet: optimizeForSpeed mode not supported falling back to standard mode."), this.flush(), this._injected = !0);
        return;
      }
      this._serverSheet = {
        cssRules: [],
        insertRule: function(m, w) {
          return typeof w == "number" ? h._serverSheet.cssRules[w] = {
            cssText: m
          } : h._serverSheet.cssRules.push({
            cssText: m
          }), w;
        },
        deleteRule: function(m) {
          h._serverSheet.cssRules[m] = null;
        }
      };
    }, y.getSheetForTag = function(h) {
      if (h.sheet)
        return h.sheet;
      for (var m = 0; m < document.styleSheets.length; m++)
        if (document.styleSheets[m].ownerNode === h)
          return document.styleSheets[m];
    }, y.getSheet = function() {
      return this.getSheetForTag(this._tags[this._tags.length - 1]);
    }, y.insertRule = function(h, m) {
      if (a(o(h), "`insertRule` accepts only strings"), typeof window == "undefined")
        return typeof m != "number" && (m = this._serverSheet.cssRules.length), this._serverSheet.insertRule(h, m), this._rulesCount++;
      if (this._optimizeForSpeed) {
        var w = this.getSheet();
        typeof m != "number" && (m = w.cssRules.length);
        try {
          w.insertRule(h, m);
        } catch ($) {
          return i || console.warn(`StyleSheet: illegal rule: 

` + h + `

See https://stackoverflow.com/q/20007992 for more info`), -1;
        }
      } else {
        var C = this._tags[m];
        this._tags.push(this.makeStyleTag(this._name, h, C));
      }
      return this._rulesCount++;
    }, y.replaceRule = function(h, m) {
      if (this._optimizeForSpeed || typeof window == "undefined") {
        var w = typeof window != "undefined" ? this.getSheet() : this._serverSheet;
        if (m.trim() || (m = this._deletedRulePlaceholder), !w.cssRules[h])
          return h;
        w.deleteRule(h);
        try {
          w.insertRule(m, h);
        } catch ($) {
          i || console.warn(`StyleSheet: illegal rule: 

` + m + `

See https://stackoverflow.com/q/20007992 for more info`), w.insertRule(this._deletedRulePlaceholder, h);
        }
      } else {
        var C = this._tags[h];
        a(C, "old rule at index `" + h + "` not found"), C.textContent = m;
      }
      return h;
    }, y.deleteRule = function(h) {
      if (typeof window == "undefined") {
        this._serverSheet.deleteRule(h);
        return;
      }
      if (this._optimizeForSpeed)
        this.replaceRule(h, "");
      else {
        var m = this._tags[h];
        a(m, "rule at index `" + h + "` not found"), m.parentNode.removeChild(m), this._tags[h] = null;
      }
    }, y.flush = function() {
      this._injected = !1, this._rulesCount = 0, typeof window != "undefined" ? (this._tags.forEach(function(h) {
        return h && h.parentNode.removeChild(h);
      }), this._tags = []) : this._serverSheet.cssRules = [];
    }, y.cssRules = function() {
      var h = this;
      return typeof window == "undefined" ? this._serverSheet.cssRules : this._tags.reduce(function(m, w) {
        return w ? m = m.concat(Array.prototype.map.call(h.getSheetForTag(w).cssRules, function(C) {
          return C.cssText === h._deletedRulePlaceholder ? null : C;
        })) : m.push(null), m;
      }, []);
    }, y.makeStyleTag = function(h, m, w) {
      m && a(o(m), "makeStyleTag accepts only strings as second parameter");
      var C = document.createElement("style");
      this._nonce && C.setAttribute("nonce", this._nonce), C.type = "text/css", C.setAttribute("data-" + h, ""), m && C.appendChild(document.createTextNode(m));
      var $ = document.head || document.getElementsByTagName("head")[0];
      return w ? $.insertBefore(C, w) : $.appendChild(C), C;
    }, r(g, [
      {
        key: "length",
        get: function() {
          return this._rulesCount;
        }
      }
    ]), g;
  })();
  function a(g, y) {
    if (!g)
      throw new Error("StyleSheet: " + y + ".");
  }
  function u(g) {
    for (var y = 5381, j = g.length; j; )
      y = y * 33 ^ g.charCodeAt(--j);
    return y >>> 0;
  }
  var d = u, x = function(g) {
    return g.replace(/\/style/gi, "\\/style");
  }, S = {};
  function R(g, y) {
    if (!y)
      return "jsx-" + g;
    var j = String(y), h = g + j;
    return S[h] || (S[h] = "jsx-" + d(g + "-" + j)), S[h];
  }
  function p(g, y) {
    var j = /__jsx-style-dynamic-selector/g;
    typeof window == "undefined" && (y = x(y));
    var h = g + y;
    return S[h] || (S[h] = y.replace(j, g)), S[h];
  }
  function _(g, y) {
    return y === void 0 && (y = {}), g.map(function(j) {
      var h = j[0], m = j[1];
      return /* @__PURE__ */ n.default.createElement("style", {
        id: "__" + h,
        // Avoid warnings upon render with a key
        key: "__" + h,
        nonce: y.nonce ? y.nonce : void 0,
        dangerouslySetInnerHTML: {
          __html: m
        }
      });
    });
  }
  var b = /* @__PURE__ */ (function() {
    function g(j) {
      var h = j === void 0 ? {} : j, m = h.styleSheet, w = m === void 0 ? null : m, C = h.optimizeForSpeed, $ = C === void 0 ? !1 : C;
      this._sheet = w || new c({
        name: "styled-jsx",
        optimizeForSpeed: $
      }), this._sheet.inject(), w && typeof $ == "boolean" && (this._sheet.setOptimizeForSpeed($), this._optimizeForSpeed = this._sheet.isOptimizeForSpeed()), this._fromServer = void 0, this._indices = {}, this._instancesCounts = {};
    }
    var y = g.prototype;
    return y.add = function(h) {
      var m = this;
      this._optimizeForSpeed === void 0 && (this._optimizeForSpeed = Array.isArray(h.children), this._sheet.setOptimizeForSpeed(this._optimizeForSpeed), this._optimizeForSpeed = this._sheet.isOptimizeForSpeed()), typeof window != "undefined" && !this._fromServer && (this._fromServer = this.selectFromServer(), this._instancesCounts = Object.keys(this._fromServer).reduce(function(D, he) {
        return D[he] = 0, D;
      }, {}));
      var w = this.getIdAndRules(h), C = w.styleId, $ = w.rules;
      if (C in this._instancesCounts) {
        this._instancesCounts[C] += 1;
        return;
      }
      var M = $.map(function(D) {
        return m._sheet.insertRule(D);
      }).filter(function(D) {
        return D !== -1;
      });
      this._indices[C] = M, this._instancesCounts[C] = 1;
    }, y.remove = function(h) {
      var m = this, w = this.getIdAndRules(h).styleId;
      if (A(w in this._instancesCounts, "styleId: `" + w + "` not found"), this._instancesCounts[w] -= 1, this._instancesCounts[w] < 1) {
        var C = this._fromServer && this._fromServer[w];
        C ? (C.parentNode.removeChild(C), delete this._fromServer[w]) : (this._indices[w].forEach(function($) {
          return m._sheet.deleteRule($);
        }), delete this._indices[w]), delete this._instancesCounts[w];
      }
    }, y.update = function(h, m) {
      this.add(m), this.remove(h);
    }, y.flush = function() {
      this._sheet.flush(), this._sheet.inject(), this._fromServer = void 0, this._indices = {}, this._instancesCounts = {};
    }, y.cssRules = function() {
      var h = this, m = this._fromServer ? Object.keys(this._fromServer).map(function(C) {
        return [
          C,
          h._fromServer[C]
        ];
      }) : [], w = this._sheet.cssRules();
      return m.concat(Object.keys(this._indices).map(function(C) {
        return [
          C,
          h._indices[C].map(function($) {
            return w[$].cssText;
          }).join(h._optimizeForSpeed ? "" : `
`)
        ];
      }).filter(function(C) {
        return !!C[1];
      }));
    }, y.styles = function(h) {
      return _(this.cssRules(), h);
    }, y.getIdAndRules = function(h) {
      var m = h.children, w = h.dynamic, C = h.id;
      if (w) {
        var $ = R(C, w);
        return {
          styleId: $,
          rules: Array.isArray(m) ? m.map(function(M) {
            return p($, M);
          }) : [
            p($, m)
          ]
        };
      }
      return {
        styleId: R(C),
        rules: Array.isArray(m) ? m : [
          m
        ]
      };
    }, y.selectFromServer = function() {
      var h = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
      return h.reduce(function(m, w) {
        var C = w.id.slice(2);
        return m[C] = w, m;
      }, {});
    }, g;
  })();
  function A(g, y) {
    if (!g)
      throw new Error("StyleSheetRegistry: " + y + ".");
  }
  var v = /* @__PURE__ */ e.createContext(null);
  v.displayName = "StyleSheetContext";
  function k() {
    return new b();
  }
  function N(g) {
    var y = g.registry, j = g.children, h = e.useContext(v), m = e.useState(function() {
      return h || y || k();
    }), w = m[0];
    return /* @__PURE__ */ n.default.createElement(v.Provider, {
      value: w
    }, j);
  }
  function F() {
    return e.useContext(v);
  }
  var Q = n.default.useInsertionEffect || n.default.useLayoutEffect, I = typeof window != "undefined" ? k() : void 0;
  function H(g) {
    var y = I || F();
    return y ? typeof window == "undefined" ? (y.add(g), null) : (Q(function() {
      return y.add(g), function() {
        y.remove(g);
      };
    }, [
      g.id,
      String(g.dynamic)
    ]), null) : null;
  }
  return H.dynamic = function(g) {
    return g.map(function(y) {
      var j = y[0], h = y[1];
      return R(j, h);
    }).join(" ");
  }, Re.StyleRegistry = N, Re.createStyleRegistry = k, Re.style = H, Re.useStyleRegistry = F, Re;
}
var ct, At;
function Jn() {
  return At || (At = 1, ct = Wn().style), ct;
}
var Xn = Jn();
const Z = /* @__PURE__ */ Vn(Xn);
function rn(e) {
  var t, n, s = "";
  if (typeof e == "string" || typeof e == "number") s += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (t = 0; t < r; t++) e[t] && (n = rn(e[t])) && (s && (s += " "), s += n);
  } else for (n in e) e[n] && (s && (s += " "), s += n);
  return s;
}
function Gn() {
  for (var e, t, n = 0, s = "", r = arguments.length; n < r; n++) (e = arguments[n]) && (t = rn(e)) && (s && (s += " "), s += t);
  return s;
}
const fe = Gn, Kn = (e) => /* @__PURE__ */ ue.createElement("svg", T({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 41 20", fill: "none" }, e), /* @__PURE__ */ ue.createElement("path", { d: "M10.1962 0.00761822C11.1031 0.00761822 12.0002 0.464711 12.7124 1.16994L17.141 6.58432C17.4408 6.31006 17.8357 6.1577 18.2449 6.15987C19.3247 6.18817 20.1879 7.05991 20.1934 8.13082V16.5707C20.1934 18.4024 18.5994 20 16.7428 20H8.20834C6.587 20 5.57941 18.1205 6.62857 16.9919L1.15737 12.6049C-0.0985676 11.3631 -0.547117 9.5293 0.912309 8.08293L8.17661 0.889155C8.69956 0.331937 9.43036 0.0108833 10.1984 0", fill: "#E40046" }), /* @__PURE__ */ ue.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.13784 9.46965L5.84415 9.41446H5.8447C5.80771 9.40244 5.80771 9.38878 5.81931 9.35654L6.03847 8.84451C6.05593 8.80295 6.0762 8.80569 6.10495 8.80959C6.11438 8.81086 6.12472 8.81226 6.13618 8.81226L6.47624 8.87456C6.50163 8.88385 6.51819 8.90243 6.50163 8.92757L6.21015 9.44452C6.18421 9.46965 6.17261 9.46965 6.13784 9.46965H6.13784ZM9.7129 9.77383C9.45973 9.68749 9.11955 9.68203 8.92802 9.68203C8.55185 9.67547 8.19939 9.86236 7.99641 10.176V9.80225C7.976 9.70498 7.8872 9.63613 7.78681 9.6405H7.08797C6.9749 9.6394 6.88224 9.72902 6.88058 9.84105V9.84323V11.9198C6.88058 12.2564 6.72228 12.746 6.18174 12.746C5.40843 12.746 5.4669 11.823 5.4669 11.823V9.8017C5.45808 9.70115 5.37038 9.62574 5.26889 9.63121H4.55626C4.45477 9.62356 4.36651 9.69897 4.35934 9.79952C4.35824 9.81263 4.35934 9.82574 4.36045 9.83885L4.36045 9.83886V11.7356C4.36045 12.7023 4.53971 13.3094 5.17346 13.5471C5.42609 13.6356 5.69305 13.6772 5.96056 13.6695C6.33728 13.6761 6.68974 13.4881 6.89216 13.1733V13.5171C6.90981 13.6154 6.99917 13.6848 7.09956 13.6788H7.7984C7.91147 13.6777 8.00303 13.5875 8.00579 13.4755V11.4312C8.00579 11.0919 8.15968 10.6006 8.70463 10.6006C9.47573 10.6006 9.41947 11.5236 9.41947 11.5236V13.5493C9.41947 13.6324 9.44484 13.6668 9.50331 13.6783H10.3676C10.5099 13.6783 10.5259 13.6553 10.5259 13.5444V11.5875C10.5259 10.6208 10.3467 10.0137 9.7129 9.77383ZM10.9493 13.6949H11.7225C11.867 13.6949 11.888 13.6719 11.888 13.561V9.77241C11.888 9.66148 11.867 9.63853 11.7225 9.63853H10.9493C10.8379 9.63853 10.7888 9.66148 10.7888 9.77241V13.561C10.7888 13.6719 10.8374 13.6949 10.9493 13.6949ZM18.7036 13.4941C18.1939 13.6963 17.6472 13.7914 17.0989 13.7733C15.7362 13.7733 15.333 13.217 15.333 12.5203C15.333 11.7471 15.8477 11.1777 16.9311 11.1777H17.7653V11.0574C17.7653 10.7804 17.6742 10.5246 17.106 10.5246C16.7458 10.5296 16.3878 10.5777 16.0391 10.6678C15.9089 10.6979 15.8714 10.6678 15.8482 10.5711L15.7269 10.0449C15.6965 9.93174 15.7269 9.90387 15.8035 9.87436C16.2741 9.71753 16.7679 9.63939 17.2638 9.64376C18.3611 9.64376 18.8642 10.105 18.8642 11.0279V13.2017C18.8824 13.3236 18.8167 13.4422 18.7036 13.4925V13.4941ZM17.1568 11.905C16.8798 11.905 16.4578 11.9558 16.4578 12.4356C16.4578 12.7886 16.7165 12.9088 17.1193 12.9088C17.3328 12.9116 17.5457 12.8788 17.7482 12.8121V11.9055H17.1562L17.1568 11.905ZM14.9529 12.6287C15.0831 12.5778 15.1112 12.5871 15.1509 12.6981L15.3628 13.2609C15.4163 13.3604 15.4234 13.4106 15.307 13.4707C14.8729 13.6828 14.3935 13.7882 13.9097 13.7779C12.7219 13.7779 12.0925 13.0855 12.0925 11.7379C12.0925 10.3904 12.819 9.6614 13.977 9.6614C14.3902 9.65429 14.8001 9.74118 15.1741 9.91495C15.3043 9.97506 15.3092 10.0051 15.2579 10.1248L15.0461 10.704C14.9948 10.815 14.9551 10.8079 14.8133 10.7685C14.5711 10.6876 14.3185 10.6428 14.063 10.6346C13.4645 10.6346 13.2361 11.1445 13.2361 11.7374C13.2361 12.3303 13.4154 12.8013 14.084 12.8013C14.3824 12.7948 14.6776 12.7358 14.9551 12.6259L14.9529 12.6287Z", fill: "#FFFFFF" }), /* @__PURE__ */ ue.createElement("path", { d: "M21.1106 8.6C21.1106 8.03995 21.1106 7.75992 21.2202 7.54601C21.3165 7.35785 21.4703 7.20487 21.6595 7.10899C21.8745 7 22.156 7 22.719 7H39.036C39.599 7 39.8805 7 40.0955 7.10899C40.2846 7.20487 40.4384 7.35785 40.5348 7.54601C40.6444 7.75992 40.6444 8.03995 40.6444 8.6V17.5794C40.6444 18.1394 40.6444 18.4194 40.5348 18.6334C40.4384 18.8215 40.2846 18.9745 40.0955 19.0704C39.8805 19.1794 39.599 19.1794 39.036 19.1794H22.719C22.156 19.1794 21.8745 19.1794 21.6595 19.0704C21.4703 18.9745 21.3165 18.8215 21.2202 18.6334C21.1106 18.4194 21.1106 18.1394 21.1106 17.5794V8.6Z", fill: "#3DAE2B" }), /* @__PURE__ */ ue.createElement("path", { d: "M38.5821 15.3213L37.9935 14.7369L37.0931 13.8444L37.2102 13.8183C38.0121 13.6518 38.5515 13.149 38.5515 12.1848C38.5515 11.0594 37.603 10.4336 36.6544 10.4315H34.6743C34.6557 10.4326 34.6371 10.4369 34.6196 10.4456C34.6053 10.4543 34.5988 10.4761 34.5988 10.5131V15.4192C34.6053 15.453 34.6152 15.4736 34.6294 15.4802C34.6524 15.4889 34.6754 15.49 34.6983 15.4856H34.7104L35.5331 15.367C35.5462 15.3659 35.5604 15.3615 35.5725 15.355C35.5878 15.3463 35.5932 15.3235 35.5932 15.2886V11.3957H36.6927C37.1675 11.3957 37.5811 11.7309 37.5811 12.176C37.5811 12.6212 37.2507 12.8464 36.7813 12.9607C36.3109 13.0739 36.0845 13.4145 36.0823 13.7737C36.0866 14.0207 36.1818 14.2569 36.3503 14.4387C36.4324 14.5442 36.5221 14.6433 36.6194 14.7369C36.6216 14.739 36.6238 14.7412 36.6271 14.7434L37.9443 16.0744C38.0263 16.1266 38.1226 16.1538 38.22 16.1538C38.4968 16.1549 38.721 15.9351 38.7254 15.6608C38.7276 15.5335 38.6762 15.4105 38.5832 15.3235M27.8924 14.0479C27.8093 13.9957 27.713 13.9674 27.6145 13.9674C27.4778 13.9674 27.3487 14.0229 27.2546 14.1209C27.2262 14.1557 27.1616 14.2156 27.1365 14.2395C26.794 14.5562 26.3422 14.7325 25.8729 14.7325C24.8445 14.7314 24.0108 13.9021 24.0097 12.878C24.013 11.8572 24.8467 11.0311 25.8729 11.0311C26.2142 11.0311 26.6802 11.0921 27.0905 11.4795C27.0949 11.4839 27.0993 11.4871 27.1047 11.4893C27.1266 11.5002 27.1507 11.5024 27.1736 11.4958L28.0532 11.3674C28.1419 11.3544 28.0992 11.2869 28.0992 11.2869C27.9427 11.0039 27.2907 10.0103 25.7853 10.0244C24.1946 10.0397 23.0043 11.2804 22.989 12.8943C22.9912 13.5724 23.2352 14.2275 23.6782 14.7423C24.2253 15.3844 25.0272 15.7555 25.8729 15.7577C26.6649 15.7555 27.4198 15.4334 27.9668 14.8631C27.9974 14.825 28.0237 14.7847 28.0467 14.7423C28.0981 14.6596 28.1254 14.5638 28.1276 14.467C28.1254 14.2983 28.0379 14.1415 27.8957 14.0501M33.3374 10.2421C32.926 10.2421 32.6908 10.5316 32.5092 10.9114L31.3856 13.2894C31.3856 13.2894 31.3747 13.3177 31.3572 13.3177C31.3397 13.3177 31.3266 13.2894 31.3266 13.2894L30.366 11.6634L30.0695 11.1574C30.052 11.1291 30.0345 11.1128 30.017 11.1117C30.0083 11.1106 29.9984 11.1106 29.9897 11.1117L28.6768 11.2956C28.6648 11.2989 28.6528 11.3032 28.6418 11.3097C28.6298 11.3174 28.6232 11.3402 28.6232 11.3761V15.6619C28.6298 15.9296 28.8508 16.144 29.1199 16.144C29.389 16.143 29.61 15.9296 29.6177 15.6619V12.3687L31.0476 14.7434L31.3539 15.2495C31.3594 15.2603 31.3692 15.2669 31.3802 15.268C31.3944 15.268 31.4031 15.2495 31.4031 15.2495L31.6515 14.7434L33.0923 11.8387V15.6423C33.0978 15.675 33.1076 15.6957 33.124 15.7033C33.1426 15.7098 33.1623 15.712 33.182 15.7098H33.1886L34.0189 15.5912C34.0354 15.5901 34.0507 15.5847 34.0649 15.5781C34.0813 15.5683 34.0846 15.5477 34.0868 15.5172V10.9909C34.0791 10.5795 33.7454 10.2486 33.3319 10.2421", fill: "#FFFFFF" })), on = "720px", Zn = "#dddddd", Qn = "#a6a6a6", pt = "#343e49", Yn = "#c0c0c0", es = "#8b8b8b", lt = "#e7e7e7", ts = "#cacaca", _t = "#f0f0f0", ns = "#767676", ss = "#4a4a4a", rs = "#bbbbbb", is = "#e0e0e0", os = "#e4022d", me = "#ffffff", jt = "#333333", as = "#717171", dt = "#000000", cs = "#FFC107", de = "'Lato', sans-serif", Qe = "12px", Ke = "14px", Ye = "16px", an = "20px", ve = [".container-recommended-products-ui.jsx-3367411885{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;gap:2px;margin-bottom:1px;}", ".container-recommended-products-ui.jsx-3367411885 .price-container.jsx-3367411885{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:4px;}", `.container-recommended-products-ui.jsx-3367411885 .price-container.jsx-3367411885 .price.jsx-3367411885{font-family:${de};color:${ss};font-weight:700;font-size:${Ye};}`, `.container-recommended-products-ui.jsx-3367411885 .price-container.jsx-3367411885 .price.oportunidad-unica.jsx-3367411885{color:${os};font-weight:400;}`, `.container-recommended-products-ui.jsx-3367411885 .price-container.jsx-3367411885 .price.crossed.jsx-3367411885{-webkit-text-decoration:line-through;text-decoration:line-through;color:${as};font-weight:400;font-size:${Qe};}`];
ve.__hash = "3367411885";
const Tt = ({
  data: e,
  Badge: t
}) => /* @__PURE__ */ O(te, { children: [
  /* @__PURE__ */ f(Z, { id: ve.__hash, children: ve }),
  /* @__PURE__ */ O("div", { className: `jsx-${ve.__hash} container-recommended-products-ui`, children: [
    e.opportunidadUnica && /* @__PURE__ */ f(Kn, { width: 41, height: 20, "data-testid": "unica-cmr" }),
    /* @__PURE__ */ O("div", { className: `jsx-${ve.__hash} price-container`, children: [
      /* @__PURE__ */ O("span", { className: `jsx-${ve.__hash} ` + (fe("price", {
        crossed: e.crossed,
        "oportunidad-unica": e.opportunidadUnica
      }) || ""), children: [
        e.symbol,
        e.originalPrice
      ] }),
      t !== void 0 && t
    ] })
  ] })
] }), De = [`.badge.jsx-3188988714{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;border-radius:3px;padding:1px 4px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;font-family:${de};font-size:12px;line-height:14px;font-weight:bold;box-sizing:border-box;}`];
De.__hash = "3188988714";
const ls = (s) => {
  var r = s, {
    backgroundColor: e = "",
    textColor: t = ""
  } = r, n = Ce(r, [
    "backgroundColor",
    "textColor"
  ]);
  const i = T({
    backgroundColor: e,
    color: t
  }, n.style);
  return /* @__PURE__ */ O(te, { children: [
    /* @__PURE__ */ f(Z, { id: De.__hash, children: De }),
    /* @__PURE__ */ f("span", V(T({}, n), { style: i, className: `jsx-${De.__hash} badge` }))
  ] });
}, ds = ({
  prices: e,
  discountBadge: t
}) => {
  const [n, ...s] = e;
  return /* @__PURE__ */ O("div", { children: [
    /* @__PURE__ */ f(() => {
      const i = t && /* @__PURE__ */ f(ls, { backgroundColor: t.styles.backgroundColor, textColor: t.styles.textColor, children: t.label });
      return /* @__PURE__ */ f(Tt, { data: n, Badge: i });
    }, {}),
    s.map((i, o) => /* @__PURE__ */ f(Tt, { data: i }, o))
  ] });
}, pe = [".container.jsx-2849234112{position:relative;}", ".star-left.jsx-2849234112{position:absolute;}", ".star-right.jsx-2849234112{position:absolute;}"];
pe.__hash = "2849234112";
const us = (o) => {
  var c = o, {
    percentage: e,
    emptyColor: t,
    filledColor: n,
    width: s = 14,
    height: r = 13
  } = c, i = Ce(c, [
    "percentage",
    "emptyColor",
    "filledColor",
    "width",
    "height"
  ]);
  const a = Math.max(0, Math.min(100, Math.round(e)));
  return /* @__PURE__ */ O(te, { children: [
    /* @__PURE__ */ f(Z, { id: pe.__hash, children: pe }),
    /* @__PURE__ */ O("div", { style: {
      width: `${s}px`,
      height: `${r}px`
    }, className: `jsx-${pe.__hash}`, children: [
      /* @__PURE__ */ f("svg", V(T({ xmlns: "http://www.w3.org/2000/svg", width: s, height: r, viewBox: "0 0 14 13", role: "img", "data-testid": `star-left-${a}`, fill: n }, i), { className: `jsx-${pe.__hash} ` + (i && i.className != null && i.className || "star-left"), children: /* @__PURE__ */ f("path", { style: {
        clipPath: `inset(0 ${100 - a}% 0 0)`
      }, d: "M13.2279 5.0701L9.00916 4.71854L7.36853 0.968536C7.30994 0.841583 7.2074 0.778107 7.06091 0.778107C6.91443 0.778107 6.81189 0.841583 6.7533 0.968536L5.09802 4.71854L0.879272 5.0701C0.732788 5.07986 0.635132 5.15311 0.586304 5.28983C0.547241 5.42654 0.581421 5.53885 0.688843 5.62674L3.89685 8.29276L2.93005 12.2625C2.90076 12.3992 2.9447 12.5115 3.06189 12.5994C3.17908 12.6775 3.30115 12.6824 3.4281 12.614L7.06091 10.5047L10.6791 12.614C10.806 12.6824 10.9281 12.6775 11.0453 12.5994C11.1722 12.5115 11.2162 12.3992 11.1771 12.2625L10.225 8.29276L13.4183 5.62674C13.5355 5.53885 13.5697 5.42654 13.5209 5.28983C13.472 5.15311 13.3744 5.07986 13.2279 5.0701Z", className: `jsx-${pe.__hash}` }) })),
      /* @__PURE__ */ f("svg", V(T({ xmlns: "http://www.w3.org/2000/svg", width: s, height: r, viewBox: "0 0 14 13", role: "img", "data-testid": `star-right-${a}`, fill: t }, i), { className: `jsx-${pe.__hash} ` + (i && i.className != null && i.className || "star-right"), children: /* @__PURE__ */ f("path", { style: {
        clipPath: `inset(0 0 0 ${a}%)`
      }, d: "M13.2279 5.0701L9.00916 4.71854L7.36853 0.968536C7.30994 0.841583 7.2074 0.778107 7.06091 0.778107C6.91443 0.778107 6.81189 0.841583 6.7533 0.968536L5.09802 4.71854L0.879272 5.0701C0.732788 5.07986 0.635132 5.15311 0.586304 5.28983C0.547241 5.42654 0.581421 5.53885 0.688843 5.62674L3.89685 8.29276L2.93005 12.2625C2.90076 12.3992 2.9447 12.5115 3.06189 12.5994C3.17908 12.6775 3.30115 12.6824 3.4281 12.614L7.06091 10.5047L10.6791 12.614C10.806 12.6824 10.9281 12.6775 11.0453 12.5994C11.1722 12.5115 11.2162 12.3992 11.1771 12.2625L10.225 8.29276L13.4183 5.62674C13.5355 5.53885 13.5697 5.42654 13.5209 5.28983C13.472 5.15311 13.3744 5.07986 13.2279 5.0701Z", className: `jsx-${pe.__hash}` }) }))
    ] })
  ] });
}, Te = [".stars.jsx-3605615881{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;gap:4px;}", ".stars.jsx-3605615881 .star-container.jsx-3605615881{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;}"];
Te.__hash = "3605615881";
const fs = ({
  rating: e,
  stars: t,
  emptyColor: n,
  filledColor: s
}) => {
  const r = Math.round(Math.max(t, 0)), i = Math.min(Math.max(e, 0), r), o = Array(r).fill(0).map((c, a) => a + 1 <= i ? 100 : a <= i ? (i - a) * 100 : 0);
  return /* @__PURE__ */ O(te, { children: [
    /* @__PURE__ */ f(Z, { id: Te.__hash, children: Te }),
    /* @__PURE__ */ f("div", { className: `jsx-${Te.__hash} stars`, children: o.map((c, a) => /* @__PURE__ */ f("div", { className: `jsx-${Te.__hash} star-container`, children: /* @__PURE__ */ f(us, { percentage: c, emptyColor: n, filledColor: s }) }, a)) })
  ] });
}, J = [".pod-container.jsx-337433758{padding-top:16px;padding-bottom:16px;position:relative;box-sizing:border-box;height:100%;}", ".pod-container.pills-wrapper.jsx-337433758{min-height:404px;}", `.pod-container.display-left-separator.jsx-337433758::before{--top:12%;content:'';position:absolute;top:var(--top);left:0;width:1px;border-radius:3px;background-color:${_t};height:calc(100% - 2 * var(--top));margin:auto 0;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);}`, ".link.jsx-337433758{height:100%;-webkit-text-decoration:none;text-decoration:none;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}", ".pod.jsx-337433758{position:relative;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}", ".image-container.jsx-337433758{width:100%;height:135px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;margin-bottom:10px;position:relative;}", ".image-container.jsx-337433758:hover{opacity:0.5;}", ".image.jsx-337433758{width:100%;max-height:100%;height:auto;object-fit:contain;}", ".brand.jsx-337433758{margin-bottom:4px;overflow:hidden;text-wrap-mode:nowrap;text-overflow:ellipsis;}", ".name.jsx-337433758{margin-bottom:6px;}", ".prices.jsx-337433758{margin-top:7px;}", ".rating-and-reviews.jsx-337433758{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;gap:5px;-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-top:4px;}", `.reviews.jsx-337433758{font-size:${Qe};color:${rs};font-family:${de};}`, ".button-container.jsx-337433758{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;margin-top:12px;padding:0 1px;-webkit-flex:1;-ms-flex:1;flex:1;-webkit-align-items:flex-end;-webkit-box-align:flex-end;-ms-flex-align:flex-end;align-items:flex-end;}", ".pod-container.jsx-337433758:has(.desktop) button.jsx-337433758{visibility:hidden;}", ".pod-container.jsx-337433758:has(.desktop):hover button.jsx-337433758{visibility:visible;}", `.button.jsx-337433758{width:100%;padding:12px 5px;font-size:${Ye};font-weight:700;font-family:${de};border-radius:4px;border:1.5px solid ${pt};background:${me};color:${pt};cursor:pointer;line-height:20px;-webkit-letter-spacing:0;-moz-letter-spacing:0;-ms-letter-spacing:0;letter-spacing:0;}`];
J.__hash = "337433758";
const He = [`.brand.jsx-2325152765{text-transform:uppercase;line-height:14px;font-size:${Qe};color:${Qn};-webkit-letter-spacing:0;-moz-letter-spacing:0;-ms-letter-spacing:0;letter-spacing:0;font-family:${de};font-weight:normal;}`];
He.__hash = "2325152765";
const hs = (e) => /* @__PURE__ */ O(te, { children: [
  /* @__PURE__ */ f(Z, { id: He.__hash, children: He }),
  /* @__PURE__ */ f("span", V(T({}, e), { className: `jsx-${He.__hash} brand` }))
] }), qe = [`.name.jsx-1763816528{font-size:${Ke};font-weight:normal;line-height:16px;color:${jt};height:34px;overflow:hidden;font-family:${de};display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;}`];
qe.__hash = "1763816528";
const ps = (e) => /* @__PURE__ */ O(te, { children: [
  /* @__PURE__ */ f(Z, { id: qe.__hash, children: qe }),
  /* @__PURE__ */ f("span", V(T({}, e), { className: `jsx-${qe.__hash} name` }))
] }), Pt = ({
  productData: e,
  deviceType: t,
  podButtonText: n = "",
  width: s,
  displayLeftSeparator: r,
  isProductButtonVisible: i,
  style: o,
  onProductClick: c,
  position: a,
  pillsButtonsWrapper: u = !1,
  buttonStyle: d = {},
  onProductClickHandler: x
}) => {
  const S = is, R = cs, p = (b) => {
    b.preventDefault(), x || (c == null || c(V(T({}, e), {
      position: a
    })), window.location.href = e == null ? void 0 : e.url);
  }, _ = (b) => {
    b.preventDefault(), x && (c == null || c(V(T({}, e), {
      position: a
    })), x(V(T({}, e), {
      position: a
    })));
  };
  return /* @__PURE__ */ O(te, { children: [
    /* @__PURE__ */ f(Z, { id: J.__hash, children: J }),
    /* @__PURE__ */ f("div", { "data-testId": "pod-container-testId", style: o, className: `jsx-${J.__hash} ` + (fe("pod-container", {
      "display-left-separator": r,
      "pills-wrapper": u
    }) || ""), children: /* @__PURE__ */ O("a", { role: "link", href: e.url, style: {
      width: s
    }, onClick: p, className: `jsx-${J.__hash} link ${t}`, children: [
      /* @__PURE__ */ O("div", { className: `jsx-${J.__hash} pod`, children: [
        /* @__PURE__ */ f("div", { className: `jsx-${J.__hash} image-container`, children: /* @__PURE__ */ f("img", { src: e.mediaUrls[0], role: "img", className: `jsx-${J.__hash} image` }) }),
        /* @__PURE__ */ f("div", { className: `jsx-${J.__hash} brand`, children: /* @__PURE__ */ f(hs, { children: e.brand }) }),
        /* @__PURE__ */ f("div", { className: `jsx-${J.__hash} name`, children: /* @__PURE__ */ f(ps, { children: e.displayName }) }),
        /* @__PURE__ */ f("div", { className: `jsx-${J.__hash} prices`, children: /* @__PURE__ */ f(ds, { prices: e.prices, discountBadge: e.discountBadge }) }),
        /* @__PURE__ */ O("div", { className: `jsx-${J.__hash} rating-and-reviews`, children: [
          e.rating > 0 && /* @__PURE__ */ f(fs, { rating: e.rating, stars: 5, emptyColor: S, filledColor: R }),
          typeof e.totalReviews == "number" && e.totalReviews > 0 && /* @__PURE__ */ O("span", { className: `jsx-${J.__hash} reviews`, children: [
            "(",
            e.totalReviews,
            ")"
          ] })
        ] })
      ] }),
      i && /* @__PURE__ */ f("div", { className: `jsx-${J.__hash} button-container`, children: /* @__PURE__ */ f("button", { "data-testId": "podButton", style: d, onClick: _, className: `jsx-${J.__hash} button`, children: n }) })
    ] }) })
  ] });
}, Pe = [".indicators.jsx-2739097974{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;gap:8px;}", `.bullet.jsx-2739097974{height:8px;width:8px;padding:0;margin:0;border:none;outline:none;border-radius:50%;background-color:${Yn};-webkit-transition:0.2s;transition:0.2s;}`, ".bullet.clickable.jsx-2739097974{cursor:pointer;}", `.bullet.jsx-2739097974:disabled{background-color:${es};cursor:initial;}`];
Pe.__hash = "2739097974";
const Ft = ({
  quantityBullets: e,
  indexActiveBullet: t,
  onClick: n
}) => {
  const s = Math.max(Math.min(t, e - 1), 0), r = new Array(e).fill(!1), i = n !== void 0;
  e > 0 && (r[s] = !0);
  const o = (c) => () => {
    i && n(c);
  };
  return /* @__PURE__ */ O(te, { children: [
    /* @__PURE__ */ f(Z, { id: Pe.__hash, children: Pe }),
    /* @__PURE__ */ f("div", { className: `jsx-${Pe.__hash} indicators`, children: r.map((c, a) => /* @__PURE__ */ f("button", { onClick: o(a), type: "button", disabled: c, "data-testid": `bullet-${a}`, className: `jsx-${Pe.__hash} ` + (fe("bullet", {
      clickable: i
    }) || "") }, a)) })
  ] });
}, ms = (e) => /* @__PURE__ */ ue.createElement("svg", T({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 13 24", fill: "none", stroke: "currentColor", strokeWidth: 2 }, e), /* @__PURE__ */ ue.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M12 23 L1 12 L12 1" })), xs = (e) => /* @__PURE__ */ ue.createElement("svg", T({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 13 24", fill: "none", stroke: "currentColor", strokeWidth: 2 }, e), /* @__PURE__ */ ue.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M1 23 L12 12 L1 1" })), bs = 30, gs = 20, ys = 135, cn = ({
  children: e,
  onVisible: t,
  threshold: n = 0.5,
  once: s = !1
}) => {
  const r = ee(null);
  return le(() => {
    const i = new IntersectionObserver(([o]) => {
      o.isIntersecting && (s && i.disconnect(), t());
    }, {
      threshold: n
    });
    return i.observe(r.current), () => {
      i.disconnect();
    };
  }, []), /* @__PURE__ */ f("div", { ref: r, children: e });
}, q = [".carousel.jsx-1685098791{max-width:100%;}", `.carousel.jsx-1685098791 .white-zone.jsx-1685098791{background-color:${me};border-radius:12px;overflow:hidden;}`, `.carousel.jsx-1685098791 .title-container.jsx-1685098791{-webkit-letter-spacing:0;-moz-letter-spacing:0;-ms-letter-spacing:0;letter-spacing:0;line-height:30px;font-weight:500;border-bottom:thin solid ${_t};background-color:${me};display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-family:${de};padding:10px 40px 10px 20px;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-align-items:flex-start;-webkit-box-align:flex-start;-ms-flex-align:flex-start;align-items:flex-start;}`, ".carousel.jsx-1685098791 .title-container.desktop.jsx-1685098791{padding:10px 40px;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}", `.carousel.jsx-1685098791 .title-container.jsx-1685098791 .title.jsx-1685098791{font-weight:400;color:${jt};margin:0;font-size:${Ye};line-height:19px;}`, `.carousel.jsx-1685098791 .title-container.jsx-1685098791 .title.desktop.jsx-1685098791{font-size:${an};line-height:30px;}`, `.carousel.jsx-1685098791 .title-container.jsx-1685098791 .sponsored.jsx-1685098791{color:${ns};font-size:${Qe};line-height:14px;font-weight:400;-webkit-letter-spacing:1px;-moz-letter-spacing:1px;-ms-letter-spacing:1px;letter-spacing:1px;margin:0;}`, ".carousel.jsx-1685098791 .body.jsx-1685098791{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}", ".carousel.jsx-1685098791 .body.jsx-1685098791 .button-container.jsx-1685098791{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:38px;}", `.carousel.jsx-1685098791 .body.jsx-1685098791 .button-container.jsx-1685098791 .button.jsx-1685098791{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;height:64px;width:34px;background-color:${me}66;cursor:pointer;border:none;color:${dt};padding:0;}`, `.carousel.jsx-1685098791 .body.jsx-1685098791 .button-container.jsx-1685098791 .button.left.jsx-1685098791{box-shadow:${dt}33 2px 0 5px -2px;margin-right:auto;}`, `.carousel.jsx-1685098791 .body.jsx-1685098791 .button-container.jsx-1685098791 .button.right.jsx-1685098791{box-shadow:${dt}33 -2px 0 5px -2px;margin-left:auto;}`, ".carousel.jsx-1685098791 .body.jsx-1685098791 .pods-wrapper.jsx-1685098791{width:100%;overflow-x:scroll;}", ".carousel.jsx-1685098791 .body.jsx-1685098791 .pods-wrapper.swipe-enabled.jsx-1685098791{overflow:hidden;}", ".carousel.jsx-1685098791 .body.jsx-1685098791 .pods-wrapper.desktop.jsx-1685098791{overflow:hidden;}", ".carousel.jsx-1685098791 .body.jsx-1685098791 .pods-wrapper.jsx-1685098791 .pods.jsx-1685098791{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:stretch;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;position:relative;left:0;-webkit-transition:left 0.5s ease-in-out;transition:left 0.5s ease-in-out;}", ".carousel.jsx-1685098791 .indicators-container.jsx-1685098791{margin-top:6px;}", ".carousel.jsx-1685098791 .indicators-container.pills-wrapper.jsx-1685098791{min-height:8px;}"];
q.__hash = "1685098791";
const ws = ({
  onSwipeLeft: e,
  onSwipeRight: t,
  threshold: n = 50
}) => {
  const s = ee(0), r = ee(0), i = at((a) => {
    s.current = a.touches[0].clientX, r.current = a.touches[0].clientX;
  }, []), o = at((a) => {
    r.current = a.touches[0].clientX;
  }, []), c = at((a) => {
    var x;
    const d = (((x = a.changedTouches[0]) == null ? void 0 : x.clientX) || r.current) - s.current;
    Math.abs(d) > n && (d > 0 ? t == null || t() : e == null || e()), s.current = 0, r.current = 0;
  }, [e, t, n]);
  return {
    onTouchStart: i,
    onTouchMove: o,
    onTouchEnd: c
  };
}, ln = [{
  name: "extraLarge",
  minWidth: 1280,
  maxPods: 6,
  width: 155,
  padding: "0 48px"
}, {
  name: "large",
  minWidth: 1024,
  maxPods: 5,
  width: 142,
  padding: "0 48px"
}, {
  name: "medium",
  minWidth: 721,
  maxPods: 4,
  width: 150,
  padding: "0 48px"
}, {
  name: "small",
  minWidth: 460,
  maxPods: 3,
  width: 150,
  padding: "0 16px"
}, {
  name: "extraSmall",
  minWidth: 0,
  maxPods: 2,
  width: 150,
  padding: "0 16px"
}], _s = (e) => {
  const t = ln.find((n) => e >= n.minWidth);
  return t ? t.maxPods : 3;
}, js = (e) => {
  const t = ln.find((n) => e >= n.minWidth);
  return t ? t.width : 150;
}, Ss = ({
  labels: e = {
    title: "",
    podButtonText: "",
    sponsoredText: ""
  },
  products: t = [],
  deviceType: n = "desktop",
  isProductButtonVisible: s = !0,
  showPaginationMobile: r = !1,
  enableAutoPlay: i = {
    isEnabled: !1,
    timeout: 4e3,
    resumeDelay: 1e4
  },
  titleStyle: o = {},
  buttonStyle: c = {},
  analytics: a = {},
  pillsButtonsWrapper: u = !1,
  onProductClickHandler: d,
  podConfig: x = {
    podWidth: ys,
    podMinSeparationDesktop: bs,
    podMinSeparationMobile: gs
  }
}) => {
  const S = n === "desktop", {
    podMinSeparationDesktop: R,
    podMinSeparationMobile: p,
    podWidth: _
  } = x, b = S ? R : p, A = S ? 48 : 20, [v, k] = K(0), [N, F] = K(b), Q = u ? A : N, [I, H] = K(_), [g, y] = K(1), [j, h] = K(!0), m = ee(null), w = ee(null), C = ee(null), $ = t.length, M = Math.ceil($ / g), D = v === 0, he = v === M - 1, Oe = v * g - (he ? g - $ % g : 0), ne = Oe + g - 1, ie = () => {
    h(!1), m.current && clearTimeout(m.current), m.current = window.setTimeout(() => {
      h(!0);
    }, i.resumeDelay || 5e3);
  }, oe = (U) => {
    var P;
    (P = a == null ? void 0 : a.onChangePage) == null || P.call(a, U), k(U), h(!1), ie();
  }, xe = () => {
    const U = C.current.clientWidth, P = Math.max(1, Math.trunc(U / (_ + b))), Y = U - P * (_ + b), Se = b + Y / P;
    F(Se), y(P), k(0);
  }, Ue = () => {
    he || oe(v + 1);
  }, Fn = () => {
    D || oe(v - 1);
  }, Rt = r && !S, Ln = ws({
    onSwipeLeft: Ue,
    onSwipeRight: Fn
  }), In = Rt ? Ln : {};
  le(() => {
    var Y;
    if (!(w != null && w.current) || !u) return;
    const U = (Y = w == null ? void 0 : w.current) == null ? void 0 : Y.clientWidth, P = js(U);
    H(P);
  }, [u]), le(() => {
    var P;
    (P = a.onRender) == null || P.call(a);
    const U = new ResizeObserver(xe);
    return U.observe(w.current), () => {
      U.disconnect();
    };
  }, []), le(() => {
    k(0);
  }, [t]), le(() => {
    if (i.isEnabled && j) {
      const U = setInterval(() => {
        k((P) => {
          var Se;
          const Y = (P + 1) % M;
          return (Se = a == null ? void 0 : a.onChangePage) == null || Se.call(a, Y), Y;
        });
      }, i.timeout);
      return () => clearInterval(U);
    }
  }, [i.isEnabled, i.timeout, M, j]), le(() => {
    xe();
  }, []), le(() => () => {
    m.current && clearTimeout(m.current);
  }, []);
  const Mn = () => {
    oe(Math.max(0, v - 1)), i.isEnabled && (h(!1), ie());
  }, Un = () => {
    oe(Math.min(v + 1, M - 1)), i.isEnabled && (h(!1), ie());
  }, zn = () => {
    if (D) return "0px";
    const U = Q + I;
    if (he) {
      const Y = $ - v * g, Se = g - Y;
      return `${-((v * g - Se) * U)}px`;
    }
    return `${-(v * g * U)}px`;
  };
  return /* @__PURE__ */ O(te, { children: [
    /* @__PURE__ */ f(Z, { id: q.__hash, children: q }),
    /* @__PURE__ */ O("div", { ref: w, className: `jsx-${q.__hash} carousel`, children: [
      /* @__PURE__ */ O("div", { className: `jsx-${q.__hash} white-zone`, children: [
        e.title && /* @__PURE__ */ O("div", { className: `jsx-${q.__hash} ` + (fe("title-container", {
          desktop: S
        }) || ""), children: [
          /* @__PURE__ */ f("h2", { style: o, className: `jsx-${q.__hash} ` + (fe("title", {
            desktop: S
          }) || ""), children: e.title }),
          /* @__PURE__ */ f("h2", { className: `jsx-${q.__hash} sponsored`, children: e.sponsoredText })
        ] }),
        /* @__PURE__ */ O("div", { className: `jsx-${q.__hash} body`, children: [
          S && /* @__PURE__ */ f("div", { className: `jsx-${q.__hash} button-container`, children: v > 0 && /* @__PURE__ */ f("button", { onClick: Mn, "data-testid": "button-left", className: `jsx-${q.__hash} button left`, children: /* @__PURE__ */ f(ms, { width: 8, height: 14 }) }) }),
          /* @__PURE__ */ f("div", V(T({}, In), { className: `jsx-${q.__hash} ` + (fe("pods-wrapper", {
            desktop: S,
            "swipe-enabled": Rt
          }) || ""), children: /* @__PURE__ */ f("div", { ref: C, style: {
            left: zn()
          }, className: `jsx-${q.__hash} pods`, children: t.map((U, P) => /* @__PURE__ */ f(sn.Fragment, { children: a.onProductImpression ? /* @__PURE__ */ f(cn, { onVisible: () => {
            var Y;
            return (Y = a == null ? void 0 : a.onProductImpression) == null ? void 0 : Y.call(a, U, P);
          }, once: !0, children: /* @__PURE__ */ f(Pt, { position: P + 1, productData: U, deviceType: n, podButtonText: e.podButtonText, isProductButtonVisible: s, width: `${_}px`, displayLeftSeparator: S ? Oe !== P && ne !== P - 1 : P !== 0, style: {
            paddingLeft: `${N / 2}px`,
            paddingRight: `${N / 2}px`
          }, onProductClick: a == null ? void 0 : a.onProductClick, pillsButtonsWrapper: u, buttonStyle: c, onProductClickHandler: d }) }) : /* @__PURE__ */ f("div", { className: `jsx-${q.__hash}`, children: /* @__PURE__ */ f(Pt, { position: P + 1, productData: U, deviceType: n, podButtonText: e.podButtonText, isProductButtonVisible: s, width: `${_}px`, displayLeftSeparator: S ? Oe !== P && ne !== P - 1 : P !== 0, style: {
            paddingLeft: `${N / 2}px`,
            paddingRight: `${N / 2}px`
          }, onProductClick: a == null ? void 0 : a.onProductClick, pillsButtonsWrapper: u, buttonStyle: c, onProductClickHandler: d }) }) }, `pod-${P}`)) }) })),
          S && /* @__PURE__ */ f("div", { className: `jsx-${q.__hash} button-container`, children: v < M - 1 && /* @__PURE__ */ f("button", { onClick: Un, "data-testid": "button-right", className: `jsx-${q.__hash} button right`, children: /* @__PURE__ */ f(xs, { width: 8, height: 14 }) }) })
        ] })
      ] }),
      /* @__PURE__ */ O("div", { className: `jsx-${q.__hash} ` + (fe("indicators-container", {
        "pills-wrapper": u
      }) || ""), children: [
        S && !r && M > 1 && /* @__PURE__ */ f(Ft, { quantityBullets: M, indexActiveBullet: v, onClick: oe }),
        !S && r && M > 1 && /* @__PURE__ */ f(Ft, { quantityBullets: M, indexActiveBullet: v, onClick: oe })
      ] })
    ] })
  ] });
}, Ve = [`.skeleton-shimmer.jsx-4121441802{width:100%;height:100%;background-color:${lt};position:relative;overflow:hidden;}`, `.skeleton-shimmer.jsx-4121441802::before{content:'';position:absolute;top:0;left:-150%;width:150%;height:100%;background:linear-gradient( 90deg, ${lt} 0.01%, ${ts} 49.5%, ${lt} 100% );-webkit-animation:skeleton-loading-jsx-4121441802 1.5s infinite;animation:skeleton-loading-jsx-4121441802 1.5s infinite;}`, "@-webkit-keyframes skeleton-loading-jsx-4121441802{0%{left:-150%;}100%{left:100%;}}", "@keyframes skeleton-loading-jsx-4121441802{0%{left:-150%;}100%{left:100%;}}"];
Ve.__hash = "4121441802";
const se = (e) => /* @__PURE__ */ O(te, { children: [
  /* @__PURE__ */ f(Z, { id: Ve.__hash, children: Ve }),
  /* @__PURE__ */ f("div", V(T({ "data-testid": "skeleton-shimmer" }, e), { className: `jsx-${Ve.__hash} skeleton-shimmer` }))
] }), We = 135, z = [".carousel.jsx-3433894198{width:100%;}", `.carousel.jsx-3433894198 .white-zone.jsx-3433894198{background-color:${me};border-radius:12px;overflow:hidden;}`, `.carousel.jsx-3433894198 .title-container.jsx-3433894198{padding:10px 40px;border-bottom:thin solid ${_t};}`, ".carousel.jsx-3433894198 .title-container.jsx-3433894198 .title.jsx-3433894198{height:30px;width:60%;}", ".carousel.jsx-3433894198 .body.jsx-3433894198{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;max-width:100%;}", ".carousel.jsx-3433894198 .body.jsx-3433894198 .pods.jsx-3433894198{width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:space-around;-webkit-justify-content:space-around;-ms-flex-pack:space-around;justify-content:space-around;-webkit-align-items:stretch;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;}", `.carousel.jsx-3433894198 .body.jsx-3433894198 .pods.jsx-3433894198 .pod.jsx-3433894198{width:${We}px;padding:16px 0;}`, `.carousel.jsx-3433894198 .body.jsx-3433894198 .pods.jsx-3433894198 .pod.jsx-3433894198 .image-container.jsx-3433894198 .image.jsx-3433894198{width:${We}px;height:${We}px;position:relative;}`, ".carousel.jsx-3433894198 .body.jsx-3433894198 .pods.jsx-3433894198 .pod.jsx-3433894198 .brand.jsx-3433894198{margin-top:4px;width:30%;height:12px;position:relative;}", ".carousel.jsx-3433894198 .body.jsx-3433894198 .pods.jsx-3433894198 .pod.jsx-3433894198 .name-1.jsx-3433894198{margin-top:4px;width:100%;height:14px;position:relative;}", ".carousel.jsx-3433894198 .body.jsx-3433894198 .pods.jsx-3433894198 .pod.jsx-3433894198 .name-2.jsx-3433894198{margin-top:2px;width:75%;height:14px;position:relative;}", ".carousel.jsx-3433894198 .body.jsx-3433894198 .pods.jsx-3433894198 .pod.jsx-3433894198 .price-1.jsx-3433894198{margin-top:8px;width:70%;height:22px;position:relative;}", ".carousel.jsx-3433894198 .body.jsx-3433894198 .pods.jsx-3433894198 .pod.jsx-3433894198 .price-2.jsx-3433894198{margin-top:3px;width:60%;height:20px;position:relative;}", ".carousel.jsx-3433894198 .body.jsx-3433894198 .pods.jsx-3433894198 .pod.jsx-3433894198 .price-3.jsx-3433894198{margin-top:3px;width:30%;height:17px;position:relative;}", ".carousel.jsx-3433894198 .body.jsx-3433894198 .pods.jsx-3433894198 .pod.jsx-3433894198 .rating.jsx-3433894198{margin-top:8px;width:90%;height:10px;position:relative;}"];
z.__hash = "3433894198";
const dn = ({
  isPillsButton: e = !1
}) => {
  const [t, n] = K(0), s = ee(null), r = ee(null);
  return le(() => {
    if (!r.current && e) return;
    let i = 6;
    if (e) {
      const a = r.current.clientWidth;
      i = _s(a);
    }
    const o = s.current.clientWidth, c = e ? i : Math.max(2, Math.trunc(o / We) - 1);
    n(c);
  }, []), /* @__PURE__ */ O(te, { children: [
    /* @__PURE__ */ f(Z, { id: z.__hash, children: z }),
    /* @__PURE__ */ f("div", { "data-testid": "skeleton-carousel", ref: r, className: `jsx-${z.__hash} carousel`, children: /* @__PURE__ */ O("div", { className: `jsx-${z.__hash} white-zone`, children: [
      !e && /* @__PURE__ */ f("div", { className: `jsx-${z.__hash} title-container`, children: /* @__PURE__ */ f("div", { className: `jsx-${z.__hash} title`, children: /* @__PURE__ */ f(se, { "data-testid": "skeleton-bar" }) }) }),
      /* @__PURE__ */ f("div", { className: `jsx-${z.__hash} body`, children: /* @__PURE__ */ f("div", { ref: s, className: `jsx-${z.__hash} pods`, children: Array.from({
        length: t
      }, (i, o) => /* @__PURE__ */ O("div", { className: `jsx-${z.__hash} pod`, children: [
        /* @__PURE__ */ f("div", { className: `jsx-${z.__hash} image-container`, children: /* @__PURE__ */ f("div", { className: `jsx-${z.__hash} image`, children: /* @__PURE__ */ f(se, { "data-testid": "skeleton-bar" }) }) }),
        /* @__PURE__ */ f("div", { className: `jsx-${z.__hash} brand`, children: /* @__PURE__ */ f(se, { "data-testid": "skeleton-bar" }) }),
        /* @__PURE__ */ f("div", { className: `jsx-${z.__hash} name-1`, children: /* @__PURE__ */ f(se, { "data-testid": "skeleton-bar" }) }),
        /* @__PURE__ */ f("div", { className: `jsx-${z.__hash} name-2`, children: /* @__PURE__ */ f(se, { "data-testid": "skeleton-bar" }) }),
        /* @__PURE__ */ f("div", { className: `jsx-${z.__hash} price-1`, children: /* @__PURE__ */ f(se, { "data-testid": "skeleton-bar" }) }),
        /* @__PURE__ */ f("div", { className: `jsx-${z.__hash} price-2`, children: /* @__PURE__ */ f(se, { "data-testid": "skeleton-bar" }) }),
        /* @__PURE__ */ f("div", { className: `jsx-${z.__hash} price-3`, children: /* @__PURE__ */ f(se, { "data-testid": "skeleton-bar" }) }),
        /* @__PURE__ */ f("div", { className: `jsx-${z.__hash} rating`, children: /* @__PURE__ */ f(se, { "data-testid": "skeleton-bar" }) })
      ] }, `pod-${o}`)) }) })
    ] }) })
  ] });
}, li = (n) => {
  var s = n, {
    showSkeleton: e = !1
  } = s, t = Ce(s, [
    "showSkeleton"
  ]);
  var r;
  return e ? /* @__PURE__ */ f(dn, {}) : (r = t.products) != null && r.length ? /* @__PURE__ */ f(Ss, T({}, t)) : null;
}, B = [`.pills-button-wrapper.jsx-2358717582 *.jsx-2358717582{box-sizing:border-box;font-family:${de};}`, `.pills-button-wrapper.jsx-2358717582{width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;background-color:${me};-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:12px 0;border-radius:4px;}`, ".header-container.jsx-2358717582{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;width:100%;overflow:hidden;}", ".title-container.jsx-2358717582{padding-inline:48px;}", ".skeleton-title-container.jsx-2358717582{width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;}", ".pills-skeleton-body.jsx-2358717582{height:370px;}", ".skeleton-title.jsx-2358717582{width:60%;height:30px;}", `.title.jsx-2358717582{font-size:${an};font-weight:700;line-height:28px;font-family:${de};margin-block:0 16px;}`, ".pills-button-container.jsx-2358717582{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;padding-inline:48px;}", ".tabs-container.jsx-2358717582{overflow-x:auto;}", ".tabs-container.jsx-2358717582::-webkit-scrollbar{width:8px;cursor:pointer;}", `.tabs.jsx-2358717582{background-color:${Zn};display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;padding:4px;border-radius:16px;gap:8px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;height:36px;overflow:hidden;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;}`, `.pill-button.jsx-2358717582{background-color:transparent;cursor:pointer;border:none;padding:4px 20px;font-size:${Ke};height:28px;text-wrap-mode:nowrap;text-align:center;}`, `.pill-button.active.jsx-2358717582{background-color:${me};border-radius:12px;}`, ".pills-body.jsx-2358717582{width:inherit;}", ".pills-body-standalone.jsx-2358717582{height:370px;position:relative;}", ".pills-body-skeleton.jsx-2358717582{min-height:418px;}", ".skeleton-buttons-container.jsx-2358717582{width:100%;margin:16px 0;padding:0 16px;}", ".skeleton-buttons.jsx-2358717582{width:100%;height:32px;}", ".footer-container.jsx-2358717582{width:100%;height:32px;}", `.know-more-button.jsx-2358717582{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;justify-self:end;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:4px 32px;color:${pt};font-size:${Ke};font-weight:700;line-height:20px;-webkit-text-decoration:underline;text-decoration:underline;text-underline-offset:4px;height:32px;}`, `@media (width <= ${on}){.tabs.jsx-2358717582{-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;}}`, "@media (width <= 460px){.title-container.jsx-2358717582{padding-inline:16px;}.pills-button-container.jsx-2358717582{padding-inline:16px;}}"];
B.__hash = "2358717582";
const di = ({
  tabs: e = [],
  children: t = null,
  showMore: n = !1,
  onClickGroupId: s = () => {
  },
  selectedGroupId: r = "",
  labels: i = {},
  variant: o = "",
  isLoading: c = !1,
  isFirstLoad: a = !1,
  lazyLoad: u = !1,
  onVisible: d = () => {
  },
  analytics: x = {}
}) => {
  const [S, R] = K(!u), p = ee(null), _ = ee(null), b = () => {
    R(!0), d();
  }, A = (k, N) => {
    var F;
    s(k == null ? void 0 : k.groupId), (F = x == null ? void 0 : x.onClick) == null || F.call(x, V(T({}, k), {
      position: N
    }));
  }, v = /* @__PURE__ */ O("div", { ref: p, className: `jsx-${B.__hash} pills-button-wrapper`, children: [
    /* @__PURE__ */ O("div", { className: `jsx-${B.__hash} header-container`, children: [
      a ? /* @__PURE__ */ f("div", { className: `jsx-${B.__hash} skeleton-title-container`, children: /* @__PURE__ */ f("div", { className: `jsx-${B.__hash} skeleton-title`, children: /* @__PURE__ */ f(se, {}) }) }) : /* @__PURE__ */ f("div", { className: `jsx-${B.__hash} title-container`, children: /* @__PURE__ */ f("h2", { className: `jsx-${B.__hash} title`, children: i == null ? void 0 : i.title }) }),
      a ? /* @__PURE__ */ f("div", { className: `jsx-${B.__hash} skeleton-buttons-container`, children: /* @__PURE__ */ f("div", { className: `jsx-${B.__hash} skeleton-buttons`, children: /* @__PURE__ */ f(se, {}) }) }) : /* @__PURE__ */ f("div", { className: `jsx-${B.__hash} pills-button-container`, children: /* @__PURE__ */ f("div", { className: `jsx-${B.__hash} tabs-container`, children: /* @__PURE__ */ f("div", { ref: _, className: `jsx-${B.__hash} ` + (fe("tabs") || ""), children: e.map((k, N) => /* @__PURE__ */ f("button", { onClick: () => A(k, N + 1), className: `jsx-${B.__hash} pill-button ${r === (k == null ? void 0 : k.groupId) ? "active" : ""}`, children: k == null ? void 0 : k.groupName }, `${k.groupId}-${N}`)) }) }) })
    ] }),
    /* @__PURE__ */ f("div", { className: `jsx-${B.__hash} ` + (fe(`pills-body pills-body-${o}`) || ""), children: c ? /* @__PURE__ */ f("div", { className: `jsx-${B.__hash} pills-body-skeleton`, children: /* @__PURE__ */ f(dn, { isPillsButton: !0 }) }) : t }),
    /* @__PURE__ */ f("div", { className: `jsx-${B.__hash} footer-container`, children: n && /* @__PURE__ */ f("a", { href: i == null ? void 0 : i.knowMoreUrl, className: `jsx-${B.__hash} know-more-button`, children: i == null ? void 0 : i.knowMoreText }) }),
    /* @__PURE__ */ f(Z, { id: B.__hash, children: B })
  ] });
  return !a && !(e != null && e.length) ? /* @__PURE__ */ f("div", { "data-testid": "pills-button-empty-groups" }) : !u || S ? v : /* @__PURE__ */ f(cn, { onVisible: b, once: !0, threshold: 0.2, children: v });
}, ye = [`.empty-state.jsx-2524009963{background:${me};width:100%;}`, ".empty-state__body.jsx-2524009963{text-align:center;min-height:322px;}", ".empty-state__body.jsx-2524009963>img.jsx-2524009963{width:320px;aspect-ratio:8/7;margin:0 auto;}", `.empty-state__body.jsx-2524009963>h2.jsx-2524009963{text-align:center;margin-block:0;margin-inline:auto;font-size:${Ye};line-height:24px;font-weight:400;font-family:${de};width:50%;}`, `.empty-state__body.jsx-2524009963 a.jsx-2524009963{color:${jt};}`, `@media (width <= ${on}){.empty-state__body.jsx-2524009963>h2.jsx-2524009963{font-size:${Ke};line-height:20px;padding-inline:16px;width:auto;}}`];
ye.__hash = "2524009963";
const ui = ({
  children: e,
  height: t,
  image: n
}) => /* @__PURE__ */ O(te, { children: [
  /* @__PURE__ */ f(Z, { id: ye.__hash, children: ye }),
  /* @__PURE__ */ f("div", { style: {
    height: t
  }, className: `jsx-${ye.__hash} empty-state`, children: /* @__PURE__ */ O("article", { className: `jsx-${ye.__hash} empty-state__body`, children: [
    /* @__PURE__ */ f("img", { src: n.src, alt: n.alt, loading: n.loading || "lazy", decoding: n.decoding || "async", className: `jsx-${ye.__hash}` }),
    /* @__PURE__ */ f("h2", { className: `jsx-${ye.__hash}`, children: e })
  ] }) })
] }), ge = {
  SODIMAC_CL: "sodimac-cl",
  HOMECENTER_CO: "homecenter-co",
  SODIMAC_AR: "sodimac-ar",
  SODIMAC_PE: "sodimac-pe",
  SODIMAC_UY: "sodimac-uy",
  SODIMAC_BR: "sodimac-br",
  SODIMAC_MX: "sodimac-mx"
}, mt = {
  channels: {
    WEB: "web"
  },
  tenants: {
    [ge.SODIMAC_CL]: {
      siteId: "socl",
      prefix: ""
    },
    [ge.SODIMAC_PE]: {
      siteId: "sope",
      prefix: "pe"
    },
    [ge.SODIMAC_MX]: {
      siteId: "somx",
      prefix: "mx"
    },
    [ge.HOMECENTER_CO]: {
      siteId: "soco",
      prefix: "co"
    },
    [ge.SODIMAC_AR]: {
      siteId: "soar",
      prefix: "ar"
    },
    [ge.SODIMAC_UY]: {
      siteId: "souy",
      prefix: "uy"
    },
    [ge.SODIMAC_BR]: {
      siteId: "sobr",
      prefix: "br"
    }
  },
  groupType: {
    BRAND: "brand",
    CATEGORY: "category"
  }
}, Lt = () => typeof window != "undefined", ks = (e) => e === "cl" || !e ? "" : `.${e}`, Cs = (e, t) => {
  const s = /sodimac\.(cl|com\.pe)/.test(e), r = ks(t);
  if (e.includes("localhost"))
    return `https://beta.falabella.com${r}`;
  if (s) {
    const i = e.replace("https://", "").split(".")[0];
    return `https://${i === "sodimac" ? "www" : i}.falabella.com${r}`;
  }
  return e;
}, It = (e = {}) => {
  const t = new URLSearchParams();
  return Object.entries(e).forEach(([n, s]) => {
    s && t.append(n, String(s));
  }), t.toString();
}, Mt = ({
  data: e,
  isStandaloneSite: t,
  minTabs: n,
  maxTabs: s
}) => {
  var i, o, c;
  const r = {
    carouselName: "",
    products: [],
    groups: []
  };
  if (!e || typeof e != "object" || ((i = Object.keys(e)) == null ? void 0 : i.length) === 0)
    return r;
  if (t) {
    const {
      widgets: a,
      groups: u
    } = e;
    r.carouselName = ((o = a == null ? void 0 : a[0]) == null ? void 0 : o.name) || "", r.products = ((c = a == null ? void 0 : a[0]) == null ? void 0 : c.data) || [], r.groups = u || [];
  } else {
    const {
      products: a,
      groups: u,
      carouselName: d
    } = e;
    r.carouselName = d || "", r.products = a || [], r.groups = u || [];
  }
  return r.groups.length < n && (r.groups = []), r.groups = r.groups.slice(0, s).map((a) => {
    var u, d;
    return V(T({}, a), {
      catalogGroupId: (d = (u = a == null ? void 0 : a.groupId) == null ? void 0 : u.split("_")) == null ? void 0 : d[0],
      rawGroupName: a == null ? void 0 : a.groupName
    });
  }), r;
}, Rs = (e, t) => e.includes("localhost") ? t === "co" ? "https://www.homecenter.com.co" : `https://beta.sodimac.com.${t}` : e, Ut = {
  getRecoDataAndes: (e) => {
    const c = e, {
      regionCode: t = "cl"
    } = c, n = Ce(c, [
      "regionCode"
    ]), s = Lt() ? window.location.origin : "", r = Cs(s, t), i = T({}, n), o = It(i);
    return `${r}/s/browse/v2/recommended-products/${t}?${o}`;
  },
  getRecoDataNonAndes: (e) => {
    var k, N;
    const v = e, {
      tenantId: t = "",
      userId: n,
      contextId: s,
      position: r,
      pageType: i,
      noCache: o,
      groupId: c
    } = v, a = Ce(v, [
      "tenantId",
      "userId",
      "contextId",
      "position",
      "pageType",
      "noCache",
      "groupId"
    ]), {
      channels: u,
      tenants: d
    } = mt, x = T({
      channel: u.WEB,
      position: r || "",
      origin: i,
      noCache: o || null,
      userId: n,
      contextId: s,
      groupId: c || ""
    }, a), S = Lt() ? window.location.origin : "", R = It(x), p = (k = d[t]) == null ? void 0 : k.siteId, _ = (N = d[t]) == null ? void 0 : N.prefix;
    return `${Rs(S, _)}/s/products/v2/${p}/recommendations?${R}`;
  }
};
function un(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: vs } = Object.prototype, { getPrototypeOf: St } = Object, { iterator: et, toStringTag: fn } = Symbol, tt = /* @__PURE__ */ ((e) => (t) => {
  const n = vs.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), re = (e) => (e = e.toLowerCase(), (t) => tt(t) === e), nt = (e) => (t) => typeof t === e, { isArray: $e } = Array, Ee = nt("undefined");
function Fe(e) {
  return e !== null && !Ee(e) && e.constructor !== null && !Ee(e.constructor) && X(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const hn = re("ArrayBuffer");
function Es(e) {
  let t;
  return typeof ArrayBuffer != "undefined" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && hn(e.buffer), t;
}
const $s = nt("string"), X = nt("function"), pn = nt("number"), Le = (e) => e !== null && typeof e == "object", Ns = (e) => e === !0 || e === !1, Je = (e) => {
  if (tt(e) !== "object")
    return !1;
  const t = St(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(fn in e) && !(et in e);
}, Os = (e) => {
  if (!Le(e) || Fe(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch (t) {
    return !1;
  }
}, As = re("Date"), Ts = re("File"), Ps = re("Blob"), Fs = re("FileList"), Ls = (e) => Le(e) && X(e.pipe), Is = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || X(e.append) && ((t = tt(e)) === "formdata" || // detect form-data instance
  t === "object" && X(e.toString) && e.toString() === "[object FormData]"));
}, Ms = re("URLSearchParams"), [Us, zs, Bs, Ds] = ["ReadableStream", "Request", "Response", "Headers"].map(re), Hs = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Ie(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e == "undefined")
    return;
  let s, r;
  if (typeof e != "object" && (e = [e]), $e(e))
    for (s = 0, r = e.length; s < r; s++)
      t.call(null, e[s], s, e);
  else {
    if (Fe(e))
      return;
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), o = i.length;
    let c;
    for (s = 0; s < o; s++)
      c = i[s], t.call(null, e[c], c, e);
  }
}
function mn(e, t) {
  if (Fe(e))
    return null;
  t = t.toLowerCase();
  const n = Object.keys(e);
  let s = n.length, r;
  for (; s-- > 0; )
    if (r = n[s], t === r.toLowerCase())
      return r;
  return null;
}
const we = typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : global, xn = (e) => !Ee(e) && e !== we;
function xt() {
  const { caseless: e, skipUndefined: t } = xn(this) && this || {}, n = {}, s = (r, i) => {
    const o = e && mn(n, i) || i;
    Je(n[o]) && Je(r) ? n[o] = xt(n[o], r) : Je(r) ? n[o] = xt({}, r) : $e(r) ? n[o] = r.slice() : (!t || !Ee(r)) && (n[o] = r);
  };
  for (let r = 0, i = arguments.length; r < i; r++)
    arguments[r] && Ie(arguments[r], s);
  return n;
}
const qs = (e, t, n, { allOwnKeys: s } = {}) => (Ie(t, (r, i) => {
  n && X(r) ? e[i] = un(r, n) : e[i] = r;
}, { allOwnKeys: s }), e), Vs = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Ws = (e, t, n, s) => {
  e.prototype = Object.create(t.prototype, s), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, Js = (e, t, n, s) => {
  let r, i, o;
  const c = {};
  if (t = t || {}, e == null) return t;
  do {
    for (r = Object.getOwnPropertyNames(e), i = r.length; i-- > 0; )
      o = r[i], (!s || s(o, e, t)) && !c[o] && (t[o] = e[o], c[o] = !0);
    e = n !== !1 && St(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, Xs = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const s = e.indexOf(t, n);
  return s !== -1 && s === n;
}, Gs = (e) => {
  if (!e) return null;
  if ($e(e)) return e;
  let t = e.length;
  if (!pn(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, Ks = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array != "undefined" && St(Uint8Array)), Zs = (e, t) => {
  const s = (e && e[et]).call(e);
  let r;
  for (; (r = s.next()) && !r.done; ) {
    const i = r.value;
    t.call(e, i[0], i[1]);
  }
}, Qs = (e, t) => {
  let n;
  const s = [];
  for (; (n = e.exec(t)) !== null; )
    s.push(n);
  return s;
}, Ys = re("HTMLFormElement"), er = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, s, r) {
    return s.toUpperCase() + r;
  }
), zt = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), tr = re("RegExp"), bn = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), s = {};
  Ie(n, (r, i) => {
    let o;
    (o = t(r, i, e)) !== !1 && (s[i] = o || r);
  }), Object.defineProperties(e, s);
}, nr = (e) => {
  bn(e, (t, n) => {
    if (X(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const s = e[n];
    if (X(s)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, sr = (e, t) => {
  const n = {}, s = (r) => {
    r.forEach((i) => {
      n[i] = !0;
    });
  };
  return $e(e) ? s(e) : s(String(e).split(t)), n;
}, rr = () => {
}, ir = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function or(e) {
  return !!(e && X(e.append) && e[fn] === "FormData" && e[et]);
}
const ar = (e) => {
  const t = new Array(10), n = (s, r) => {
    if (Le(s)) {
      if (t.indexOf(s) >= 0)
        return;
      if (Fe(s))
        return s;
      if (!("toJSON" in s)) {
        t[r] = s;
        const i = $e(s) ? [] : {};
        return Ie(s, (o, c) => {
          const a = n(o, r + 1);
          !Ee(a) && (i[c] = a);
        }), t[r] = void 0, i;
      }
    }
    return s;
  };
  return n(e, 0);
}, cr = re("AsyncFunction"), lr = (e) => e && (Le(e) || X(e)) && X(e.then) && X(e.catch), gn = ((e, t) => e ? setImmediate : t ? ((n, s) => (we.addEventListener("message", ({ source: r, data: i }) => {
  r === we && i === n && s.length && s.shift()();
}, !1), (r) => {
  s.push(r), we.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  X(we.postMessage)
), dr = typeof queueMicrotask != "undefined" ? queueMicrotask.bind(we) : typeof process != "undefined" && process.nextTick || gn, ur = (e) => e != null && X(e[et]), l = {
  isArray: $e,
  isArrayBuffer: hn,
  isBuffer: Fe,
  isFormData: Is,
  isArrayBufferView: Es,
  isString: $s,
  isNumber: pn,
  isBoolean: Ns,
  isObject: Le,
  isPlainObject: Je,
  isEmptyObject: Os,
  isReadableStream: Us,
  isRequest: zs,
  isResponse: Bs,
  isHeaders: Ds,
  isUndefined: Ee,
  isDate: As,
  isFile: Ts,
  isBlob: Ps,
  isRegExp: tr,
  isFunction: X,
  isStream: Ls,
  isURLSearchParams: Ms,
  isTypedArray: Ks,
  isFileList: Fs,
  forEach: Ie,
  merge: xt,
  extend: qs,
  trim: Hs,
  stripBOM: Vs,
  inherits: Ws,
  toFlatObject: Js,
  kindOf: tt,
  kindOfTest: re,
  endsWith: Xs,
  toArray: Gs,
  forEachEntry: Zs,
  matchAll: Qs,
  isHTMLForm: Ys,
  hasOwnProperty: zt,
  hasOwnProp: zt,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: bn,
  freezeMethods: nr,
  toObjectSet: sr,
  toCamelCase: er,
  noop: rr,
  toFiniteNumber: ir,
  findKey: mn,
  global: we,
  isContextDefined: xn,
  isSpecCompliantForm: or,
  toJSONObject: ar,
  isAsyncFn: cr,
  isThenable: lr,
  setImmediate: gn,
  asap: dr,
  isIterable: ur
};
function E(e, t, n, s, r) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), s && (this.request = s), r && (this.response = r, this.status = r.status ? r.status : null);
}
l.inherits(E, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: l.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const yn = E.prototype, wn = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  wn[e] = { value: e };
});
Object.defineProperties(E, wn);
Object.defineProperty(yn, "isAxiosError", { value: !0 });
E.from = (e, t, n, s, r, i) => {
  const o = Object.create(yn);
  l.toFlatObject(e, o, function(d) {
    return d !== Error.prototype;
  }, (u) => u !== "isAxiosError");
  const c = e && e.message ? e.message : "Error", a = t == null && e ? e.code : t;
  return E.call(o, c, a, n, s, r), e && o.cause == null && Object.defineProperty(o, "cause", { value: e, configurable: !0 }), o.name = e && e.name || "Error", i && Object.assign(o, i), o;
};
const fr = null;
function bt(e) {
  return l.isPlainObject(e) || l.isArray(e);
}
function _n(e) {
  return l.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Bt(e, t, n) {
  return e ? e.concat(t).map(function(r, i) {
    return r = _n(r), !n && i ? "[" + r + "]" : r;
  }).join(n ? "." : "") : t;
}
function hr(e) {
  return l.isArray(e) && !e.some(bt);
}
const pr = l.toFlatObject(l, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function st(e, t, n) {
  if (!l.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = l.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(_, b) {
    return !l.isUndefined(b[_]);
  });
  const s = n.metaTokens, r = n.visitor || d, i = n.dots, o = n.indexes, a = (n.Blob || typeof Blob != "undefined" && Blob) && l.isSpecCompliantForm(t);
  if (!l.isFunction(r))
    throw new TypeError("visitor must be a function");
  function u(p) {
    if (p === null) return "";
    if (l.isDate(p))
      return p.toISOString();
    if (l.isBoolean(p))
      return p.toString();
    if (!a && l.isBlob(p))
      throw new E("Blob is not supported. Use a Buffer instead.");
    return l.isArrayBuffer(p) || l.isTypedArray(p) ? a && typeof Blob == "function" ? new Blob([p]) : Buffer.from(p) : p;
  }
  function d(p, _, b) {
    let A = p;
    if (p && !b && typeof p == "object") {
      if (l.endsWith(_, "{}"))
        _ = s ? _ : _.slice(0, -2), p = JSON.stringify(p);
      else if (l.isArray(p) && hr(p) || (l.isFileList(p) || l.endsWith(_, "[]")) && (A = l.toArray(p)))
        return _ = _n(_), A.forEach(function(k, N) {
          !(l.isUndefined(k) || k === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? Bt([_], N, i) : o === null ? _ : _ + "[]",
            u(k)
          );
        }), !1;
    }
    return bt(p) ? !0 : (t.append(Bt(b, _, i), u(p)), !1);
  }
  const x = [], S = Object.assign(pr, {
    defaultVisitor: d,
    convertValue: u,
    isVisitable: bt
  });
  function R(p, _) {
    if (!l.isUndefined(p)) {
      if (x.indexOf(p) !== -1)
        throw Error("Circular reference detected in " + _.join("."));
      x.push(p), l.forEach(p, function(A, v) {
        (!(l.isUndefined(A) || A === null) && r.call(
          t,
          A,
          l.isString(v) ? v.trim() : v,
          _,
          S
        )) === !0 && R(A, _ ? _.concat(v) : [v]);
      }), x.pop();
    }
  }
  if (!l.isObject(e))
    throw new TypeError("data must be an object");
  return R(e), t;
}
function Dt(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(s) {
    return t[s];
  });
}
function kt(e, t) {
  this._pairs = [], e && st(e, this, t);
}
const jn = kt.prototype;
jn.append = function(t, n) {
  this._pairs.push([t, n]);
};
jn.toString = function(t) {
  const n = t ? function(s) {
    return t.call(this, s, Dt);
  } : Dt;
  return this._pairs.map(function(r) {
    return n(r[0]) + "=" + n(r[1]);
  }, "").join("&");
};
function mr(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Sn(e, t, n) {
  if (!t)
    return e;
  const s = n && n.encode || mr;
  l.isFunction(n) && (n = {
    serialize: n
  });
  const r = n && n.serialize;
  let i;
  if (r ? i = r(t, n) : i = l.isURLSearchParams(t) ? t.toString() : new kt(t, n).toString(s), i) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class Ht {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, s) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: s ? s.synchronous : !1,
      runWhen: s ? s.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    l.forEach(this.handlers, function(s) {
      s !== null && t(s);
    });
  }
}
const kn = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, xr = typeof URLSearchParams != "undefined" ? URLSearchParams : kt, br = typeof FormData != "undefined" ? FormData : null, gr = typeof Blob != "undefined" ? Blob : null, yr = {
  isBrowser: !0,
  classes: {
    URLSearchParams: xr,
    FormData: br,
    Blob: gr
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Ct = typeof window != "undefined" && typeof document != "undefined", gt = typeof navigator == "object" && navigator || void 0, wr = Ct && (!gt || ["ReactNative", "NativeScript", "NS"].indexOf(gt.product) < 0), _r = typeof WorkerGlobalScope != "undefined" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", jr = Ct && window.location.href || "http://localhost", Sr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Ct,
  hasStandardBrowserEnv: wr,
  hasStandardBrowserWebWorkerEnv: _r,
  navigator: gt,
  origin: jr
}, Symbol.toStringTag, { value: "Module" })), W = T(T({}, Sr), yr);
function kr(e, t) {
  return st(e, new W.classes.URLSearchParams(), T({
    visitor: function(n, s, r, i) {
      return W.isNode && l.isBuffer(n) ? (this.append(s, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function Cr(e) {
  return l.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Rr(e) {
  const t = {}, n = Object.keys(e);
  let s;
  const r = n.length;
  let i;
  for (s = 0; s < r; s++)
    i = n[s], t[i] = e[i];
  return t;
}
function Cn(e) {
  function t(n, s, r, i) {
    let o = n[i++];
    if (o === "__proto__") return !0;
    const c = Number.isFinite(+o), a = i >= n.length;
    return o = !o && l.isArray(r) ? r.length : o, a ? (l.hasOwnProp(r, o) ? r[o] = [r[o], s] : r[o] = s, !c) : ((!r[o] || !l.isObject(r[o])) && (r[o] = []), t(n, s, r[o], i) && l.isArray(r[o]) && (r[o] = Rr(r[o])), !c);
  }
  if (l.isFormData(e) && l.isFunction(e.entries)) {
    const n = {};
    return l.forEachEntry(e, (s, r) => {
      t(Cr(s), r, n, 0);
    }), n;
  }
  return null;
}
function vr(e, t, n) {
  if (l.isString(e))
    try {
      return (t || JSON.parse)(e), l.trim(e);
    } catch (s) {
      if (s.name !== "SyntaxError")
        throw s;
    }
  return (n || JSON.stringify)(e);
}
const Me = {
  transitional: kn,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const s = n.getContentType() || "", r = s.indexOf("application/json") > -1, i = l.isObject(t);
    if (i && l.isHTMLForm(t) && (t = new FormData(t)), l.isFormData(t))
      return r ? JSON.stringify(Cn(t)) : t;
    if (l.isArrayBuffer(t) || l.isBuffer(t) || l.isStream(t) || l.isFile(t) || l.isBlob(t) || l.isReadableStream(t))
      return t;
    if (l.isArrayBufferView(t))
      return t.buffer;
    if (l.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let c;
    if (i) {
      if (s.indexOf("application/x-www-form-urlencoded") > -1)
        return kr(t, this.formSerializer).toString();
      if ((c = l.isFileList(t)) || s.indexOf("multipart/form-data") > -1) {
        const a = this.env && this.env.FormData;
        return st(
          c ? { "files[]": t } : t,
          a && new a(),
          this.formSerializer
        );
      }
    }
    return i || r ? (n.setContentType("application/json", !1), vr(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || Me.transitional, s = n && n.forcedJSONParsing, r = this.responseType === "json";
    if (l.isResponse(t) || l.isReadableStream(t))
      return t;
    if (t && l.isString(t) && (s && !this.responseType || r)) {
      const o = !(n && n.silentJSONParsing) && r;
      try {
        return JSON.parse(t, this.parseReviver);
      } catch (c) {
        if (o)
          throw c.name === "SyntaxError" ? E.from(c, E.ERR_BAD_RESPONSE, this, null, this.response) : c;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: W.classes.FormData,
    Blob: W.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
l.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Me.headers[e] = {};
});
const Er = l.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), $r = (e) => {
  const t = {};
  let n, s, r;
  return e && e.split(`
`).forEach(function(o) {
    r = o.indexOf(":"), n = o.substring(0, r).trim().toLowerCase(), s = o.substring(r + 1).trim(), !(!n || t[n] && Er[n]) && (n === "set-cookie" ? t[n] ? t[n].push(s) : t[n] = [s] : t[n] = t[n] ? t[n] + ", " + s : s);
  }), t;
}, qt = Symbol("internals");
function Ae(e) {
  return e && String(e).trim().toLowerCase();
}
function Xe(e) {
  return e === !1 || e == null ? e : l.isArray(e) ? e.map(Xe) : String(e);
}
function Nr(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let s;
  for (; s = n.exec(e); )
    t[s[1]] = s[2];
  return t;
}
const Or = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function ut(e, t, n, s, r) {
  if (l.isFunction(s))
    return s.call(this, t, n);
  if (r && (t = n), !!l.isString(t)) {
    if (l.isString(s))
      return t.indexOf(s) !== -1;
    if (l.isRegExp(s))
      return s.test(t);
  }
}
function Ar(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, s) => n.toUpperCase() + s);
}
function Tr(e, t) {
  const n = l.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((s) => {
    Object.defineProperty(e, s + n, {
      value: function(r, i, o) {
        return this[s].call(this, t, r, i, o);
      },
      configurable: !0
    });
  });
}
let G = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, s) {
    const r = this;
    function i(c, a, u) {
      const d = Ae(a);
      if (!d)
        throw new Error("header name must be a non-empty string");
      const x = l.findKey(r, d);
      (!x || r[x] === void 0 || u === !0 || u === void 0 && r[x] !== !1) && (r[x || a] = Xe(c));
    }
    const o = (c, a) => l.forEach(c, (u, d) => i(u, d, a));
    if (l.isPlainObject(t) || t instanceof this.constructor)
      o(t, n);
    else if (l.isString(t) && (t = t.trim()) && !Or(t))
      o($r(t), n);
    else if (l.isObject(t) && l.isIterable(t)) {
      let c = {}, a, u;
      for (const d of t) {
        if (!l.isArray(d))
          throw TypeError("Object iterator must return a key-value pair");
        c[u = d[0]] = (a = c[u]) ? l.isArray(a) ? [...a, d[1]] : [a, d[1]] : d[1];
      }
      o(c, n);
    } else
      t != null && i(n, t, s);
    return this;
  }
  get(t, n) {
    if (t = Ae(t), t) {
      const s = l.findKey(this, t);
      if (s) {
        const r = this[s];
        if (!n)
          return r;
        if (n === !0)
          return Nr(r);
        if (l.isFunction(n))
          return n.call(this, r, s);
        if (l.isRegExp(n))
          return n.exec(r);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = Ae(t), t) {
      const s = l.findKey(this, t);
      return !!(s && this[s] !== void 0 && (!n || ut(this, this[s], s, n)));
    }
    return !1;
  }
  delete(t, n) {
    const s = this;
    let r = !1;
    function i(o) {
      if (o = Ae(o), o) {
        const c = l.findKey(s, o);
        c && (!n || ut(s, s[c], c, n)) && (delete s[c], r = !0);
      }
    }
    return l.isArray(t) ? t.forEach(i) : i(t), r;
  }
  clear(t) {
    const n = Object.keys(this);
    let s = n.length, r = !1;
    for (; s--; ) {
      const i = n[s];
      (!t || ut(this, this[i], i, t, !0)) && (delete this[i], r = !0);
    }
    return r;
  }
  normalize(t) {
    const n = this, s = {};
    return l.forEach(this, (r, i) => {
      const o = l.findKey(s, i);
      if (o) {
        n[o] = Xe(r), delete n[i];
        return;
      }
      const c = t ? Ar(i) : String(i).trim();
      c !== i && delete n[i], n[c] = Xe(r), s[c] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return l.forEach(this, (s, r) => {
      s != null && s !== !1 && (n[r] = t && l.isArray(s) ? s.join(", ") : s);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const s = new this(t);
    return n.forEach((r) => s.set(r)), s;
  }
  static accessor(t) {
    const s = (this[qt] = this[qt] = {
      accessors: {}
    }).accessors, r = this.prototype;
    function i(o) {
      const c = Ae(o);
      s[c] || (Tr(r, o), s[c] = !0);
    }
    return l.isArray(t) ? t.forEach(i) : i(t), this;
  }
};
G.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
l.reduceDescriptors(G.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(s) {
      this[n] = s;
    }
  };
});
l.freezeMethods(G);
function ft(e, t) {
  const n = this || Me, s = t || n, r = G.from(s.headers);
  let i = s.data;
  return l.forEach(e, function(c) {
    i = c.call(n, i, r.normalize(), t ? t.status : void 0);
  }), r.normalize(), i;
}
function Rn(e) {
  return !!(e && e.__CANCEL__);
}
function Ne(e, t, n) {
  E.call(this, e == null ? "canceled" : e, E.ERR_CANCELED, t, n), this.name = "CanceledError";
}
l.inherits(Ne, E, {
  __CANCEL__: !0
});
function vn(e, t, n) {
  const s = n.config.validateStatus;
  !n.status || !s || s(n.status) ? e(n) : t(new E(
    "Request failed with status code " + n.status,
    [E.ERR_BAD_REQUEST, E.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function Pr(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function Fr(e, t) {
  e = e || 10;
  const n = new Array(e), s = new Array(e);
  let r = 0, i = 0, o;
  return t = t !== void 0 ? t : 1e3, function(a) {
    const u = Date.now(), d = s[i];
    o || (o = u), n[r] = a, s[r] = u;
    let x = i, S = 0;
    for (; x !== r; )
      S += n[x++], x = x % e;
    if (r = (r + 1) % e, r === i && (i = (i + 1) % e), u - o < t)
      return;
    const R = d && u - d;
    return R ? Math.round(S * 1e3 / R) : void 0;
  };
}
function Lr(e, t) {
  let n = 0, s = 1e3 / t, r, i;
  const o = (u, d = Date.now()) => {
    n = d, r = null, i && (clearTimeout(i), i = null), e(...u);
  };
  return [(...u) => {
    const d = Date.now(), x = d - n;
    x >= s ? o(u, d) : (r = u, i || (i = setTimeout(() => {
      i = null, o(r);
    }, s - x)));
  }, () => r && o(r)];
}
const Ze = (e, t, n = 3) => {
  let s = 0;
  const r = Fr(50, 250);
  return Lr((i) => {
    const o = i.loaded, c = i.lengthComputable ? i.total : void 0, a = o - s, u = r(a), d = o <= c;
    s = o;
    const x = {
      loaded: o,
      total: c,
      progress: c ? o / c : void 0,
      bytes: a,
      rate: u || void 0,
      estimated: u && c && d ? (c - o) / u : void 0,
      event: i,
      lengthComputable: c != null,
      [t ? "download" : "upload"]: !0
    };
    e(x);
  }, n);
}, Vt = (e, t) => {
  const n = e != null;
  return [(s) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: s
  }), t[1]];
}, Wt = (e) => (...t) => l.asap(() => e(...t)), Ir = W.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, W.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(W.origin),
  W.navigator && /(msie|trident)/i.test(W.navigator.userAgent)
) : () => !0, Mr = W.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, s, r, i) {
      const o = [e + "=" + encodeURIComponent(t)];
      l.isNumber(n) && o.push("expires=" + new Date(n).toGMTString()), l.isString(s) && o.push("path=" + s), l.isString(r) && o.push("domain=" + r), i === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Ur(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function zr(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function En(e, t, n) {
  let s = !Ur(t);
  return e && (s || n == !1) ? zr(e, t) : t;
}
const Jt = (e) => e instanceof G ? T({}, e) : e;
function je(e, t) {
  t = t || {};
  const n = {};
  function s(u, d, x, S) {
    return l.isPlainObject(u) && l.isPlainObject(d) ? l.merge.call({ caseless: S }, u, d) : l.isPlainObject(d) ? l.merge({}, d) : l.isArray(d) ? d.slice() : d;
  }
  function r(u, d, x, S) {
    if (l.isUndefined(d)) {
      if (!l.isUndefined(u))
        return s(void 0, u, x, S);
    } else return s(u, d, x, S);
  }
  function i(u, d) {
    if (!l.isUndefined(d))
      return s(void 0, d);
  }
  function o(u, d) {
    if (l.isUndefined(d)) {
      if (!l.isUndefined(u))
        return s(void 0, u);
    } else return s(void 0, d);
  }
  function c(u, d, x) {
    if (x in t)
      return s(u, d);
    if (x in e)
      return s(void 0, u);
  }
  const a = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: c,
    headers: (u, d, x) => r(Jt(u), Jt(d), x, !0)
  };
  return l.forEach(Object.keys(T(T({}, e), t)), function(d) {
    const x = a[d] || r, S = x(e[d], t[d], d);
    l.isUndefined(S) && x !== c || (n[d] = S);
  }), n;
}
const $n = (e) => {
  const t = je({}, e);
  let { data: n, withXSRFToken: s, xsrfHeaderName: r, xsrfCookieName: i, headers: o, auth: c } = t;
  if (t.headers = o = G.from(o), t.url = Sn(En(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), c && o.set(
    "Authorization",
    "Basic " + btoa((c.username || "") + ":" + (c.password ? unescape(encodeURIComponent(c.password)) : ""))
  ), l.isFormData(n)) {
    if (W.hasStandardBrowserEnv || W.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if (l.isFunction(n.getHeaders)) {
      const a = n.getHeaders(), u = ["content-type", "content-length"];
      Object.entries(a).forEach(([d, x]) => {
        u.includes(d.toLowerCase()) && o.set(d, x);
      });
    }
  }
  if (W.hasStandardBrowserEnv && (s && l.isFunction(s) && (s = s(t)), s || s !== !1 && Ir(t.url))) {
    const a = r && i && Mr.read(i);
    a && o.set(r, a);
  }
  return t;
}, Br = typeof XMLHttpRequest != "undefined", Dr = Br && function(e) {
  return new Promise(function(n, s) {
    const r = $n(e);
    let i = r.data;
    const o = G.from(r.headers).normalize();
    let { responseType: c, onUploadProgress: a, onDownloadProgress: u } = r, d, x, S, R, p;
    function _() {
      R && R(), p && p(), r.cancelToken && r.cancelToken.unsubscribe(d), r.signal && r.signal.removeEventListener("abort", d);
    }
    let b = new XMLHttpRequest();
    b.open(r.method.toUpperCase(), r.url, !0), b.timeout = r.timeout;
    function A() {
      if (!b)
        return;
      const k = G.from(
        "getAllResponseHeaders" in b && b.getAllResponseHeaders()
      ), F = {
        data: !c || c === "text" || c === "json" ? b.responseText : b.response,
        status: b.status,
        statusText: b.statusText,
        headers: k,
        config: e,
        request: b
      };
      vn(function(I) {
        n(I), _();
      }, function(I) {
        s(I), _();
      }, F), b = null;
    }
    "onloadend" in b ? b.onloadend = A : b.onreadystatechange = function() {
      !b || b.readyState !== 4 || b.status === 0 && !(b.responseURL && b.responseURL.indexOf("file:") === 0) || setTimeout(A);
    }, b.onabort = function() {
      b && (s(new E("Request aborted", E.ECONNABORTED, e, b)), b = null);
    }, b.onerror = function(N) {
      const F = N && N.message ? N.message : "Network Error", Q = new E(F, E.ERR_NETWORK, e, b);
      Q.event = N || null, s(Q), b = null;
    }, b.ontimeout = function() {
      let N = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const F = r.transitional || kn;
      r.timeoutErrorMessage && (N = r.timeoutErrorMessage), s(new E(
        N,
        F.clarifyTimeoutError ? E.ETIMEDOUT : E.ECONNABORTED,
        e,
        b
      )), b = null;
    }, i === void 0 && o.setContentType(null), "setRequestHeader" in b && l.forEach(o.toJSON(), function(N, F) {
      b.setRequestHeader(F, N);
    }), l.isUndefined(r.withCredentials) || (b.withCredentials = !!r.withCredentials), c && c !== "json" && (b.responseType = r.responseType), u && ([S, p] = Ze(u, !0), b.addEventListener("progress", S)), a && b.upload && ([x, R] = Ze(a), b.upload.addEventListener("progress", x), b.upload.addEventListener("loadend", R)), (r.cancelToken || r.signal) && (d = (k) => {
      b && (s(!k || k.type ? new Ne(null, e, b) : k), b.abort(), b = null);
    }, r.cancelToken && r.cancelToken.subscribe(d), r.signal && (r.signal.aborted ? d() : r.signal.addEventListener("abort", d)));
    const v = Pr(r.url);
    if (v && W.protocols.indexOf(v) === -1) {
      s(new E("Unsupported protocol " + v + ":", E.ERR_BAD_REQUEST, e));
      return;
    }
    b.send(i || null);
  });
}, Hr = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let s = new AbortController(), r;
    const i = function(u) {
      if (!r) {
        r = !0, c();
        const d = u instanceof Error ? u : this.reason;
        s.abort(d instanceof E ? d : new Ne(d instanceof Error ? d.message : d));
      }
    };
    let o = t && setTimeout(() => {
      o = null, i(new E(`timeout ${t} of ms exceeded`, E.ETIMEDOUT));
    }, t);
    const c = () => {
      e && (o && clearTimeout(o), o = null, e.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(i) : u.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((u) => u.addEventListener("abort", i));
    const { signal: a } = s;
    return a.unsubscribe = () => l.asap(c), a;
  }
}, qr = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let s = 0, r;
  for (; s < n; )
    r = s + t, yield e.slice(s, r), s = r;
}, Vr = function(e, t) {
  return it(this, null, function* () {
    try {
      for (var n = Nt(Wr(e)), s, r, i; s = !(r = yield new be(n.next())).done; s = !1) {
        const o = r.value;
        yield* ot(qr(o, t));
      }
    } catch (r) {
      i = [r];
    } finally {
      try {
        s && (r = n.return) && (yield new be(r.call(n)));
      } finally {
        if (i)
          throw i[0];
      }
    }
  });
}, Wr = function(e) {
  return it(this, null, function* () {
    if (e[Symbol.asyncIterator]) {
      yield* ot(e);
      return;
    }
    const t = e.getReader();
    try {
      for (; ; ) {
        const { done: n, value: s } = yield new be(t.read());
        if (n)
          break;
        yield s;
      }
    } finally {
      yield new be(t.cancel());
    }
  });
}, Xt = (e, t, n, s) => {
  const r = Vr(e, t);
  let i = 0, o, c = (u) => {
    o || (o = !0, s && s(u));
  };
  return new ReadableStream({
    pull(u) {
      return ae(this, null, function* () {
        try {
          const { done: d, value: x } = yield r.next();
          if (d) {
            c(), u.close();
            return;
          }
          let S = x.byteLength;
          if (n) {
            let R = i += S;
            n(R);
          }
          u.enqueue(new Uint8Array(x));
        } catch (d) {
          throw c(d), d;
        }
      });
    },
    cancel(u) {
      return c(u), r.return();
    }
  }, {
    highWaterMark: 2
  });
}, Gt = 64 * 1024, { isFunction: Be } = l, Jr = (({ Request: e, Response: t }) => ({
  Request: e,
  Response: t
}))(l.global), {
  ReadableStream: Kt,
  TextEncoder: Zt
} = l.global, Qt = (e, ...t) => {
  try {
    return !!e(...t);
  } catch (n) {
    return !1;
  }
}, Xr = (e) => {
  e = l.merge.call({
    skipUndefined: !0
  }, Jr, e);
  const { fetch: t, Request: n, Response: s } = e, r = t ? Be(t) : typeof fetch == "function", i = Be(n), o = Be(s);
  if (!r)
    return !1;
  const c = r && Be(Kt), a = r && (typeof Zt == "function" ? /* @__PURE__ */ ((p) => (_) => p.encode(_))(new Zt()) : (p) => ae(null, null, function* () {
    return new Uint8Array(yield new n(p).arrayBuffer());
  })), u = i && c && Qt(() => {
    let p = !1;
    const _ = new n(W.origin, {
      body: new Kt(),
      method: "POST",
      get duplex() {
        return p = !0, "half";
      }
    }).headers.has("Content-Type");
    return p && !_;
  }), d = o && c && Qt(() => l.isReadableStream(new s("").body)), x = {
    stream: d && ((p) => p.body)
  };
  r && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((p) => {
    !x[p] && (x[p] = (_, b) => {
      let A = _ && _[p];
      if (A)
        return A.call(_);
      throw new E(`Response type '${p}' is not supported`, E.ERR_NOT_SUPPORT, b);
    });
  });
  const S = (p) => ae(null, null, function* () {
    if (p == null)
      return 0;
    if (l.isBlob(p))
      return p.size;
    if (l.isSpecCompliantForm(p))
      return (yield new n(W.origin, {
        method: "POST",
        body: p
      }).arrayBuffer()).byteLength;
    if (l.isArrayBufferView(p) || l.isArrayBuffer(p))
      return p.byteLength;
    if (l.isURLSearchParams(p) && (p = p + ""), l.isString(p))
      return (yield a(p)).byteLength;
  }), R = (p, _) => ae(null, null, function* () {
    const b = l.toFiniteNumber(p.getContentLength());
    return b == null ? S(_) : b;
  });
  return (p) => ae(null, null, function* () {
    let {
      url: _,
      method: b,
      data: A,
      signal: v,
      cancelToken: k,
      timeout: N,
      onDownloadProgress: F,
      onUploadProgress: Q,
      responseType: I,
      headers: H,
      withCredentials: g = "same-origin",
      fetchOptions: y
    } = $n(p), j = t || fetch;
    I = I ? (I + "").toLowerCase() : "text";
    let h = Hr([v, k && k.toAbortSignal()], N), m = null;
    const w = h && h.unsubscribe && (() => {
      h.unsubscribe();
    });
    let C;
    try {
      if (Q && u && b !== "get" && b !== "head" && (C = yield R(H, A)) !== 0) {
        let ne = new n(_, {
          method: "POST",
          body: A,
          duplex: "half"
        }), ie;
        if (l.isFormData(A) && (ie = ne.headers.get("content-type")) && H.setContentType(ie), ne.body) {
          const [oe, xe] = Vt(
            C,
            Ze(Wt(Q))
          );
          A = Xt(ne.body, Gt, oe, xe);
        }
      }
      l.isString(g) || (g = g ? "include" : "omit");
      const $ = i && "credentials" in n.prototype, M = V(T({}, y), {
        signal: h,
        method: b.toUpperCase(),
        headers: H.normalize().toJSON(),
        body: A,
        duplex: "half",
        credentials: $ ? g : void 0
      });
      m = i && new n(_, M);
      let D = yield i ? j(m, y) : j(_, M);
      const he = d && (I === "stream" || I === "response");
      if (d && (F || he && w)) {
        const ne = {};
        ["status", "statusText", "headers"].forEach((Ue) => {
          ne[Ue] = D[Ue];
        });
        const ie = l.toFiniteNumber(D.headers.get("content-length")), [oe, xe] = F && Vt(
          ie,
          Ze(Wt(F), !0)
        ) || [];
        D = new s(
          Xt(D.body, Gt, oe, () => {
            xe && xe(), w && w();
          }),
          ne
        );
      }
      I = I || "text";
      let Oe = yield x[l.findKey(x, I) || "text"](D, p);
      return !he && w && w(), yield new Promise((ne, ie) => {
        vn(ne, ie, {
          data: Oe,
          headers: G.from(D.headers),
          status: D.status,
          statusText: D.statusText,
          config: p,
          request: m
        });
      });
    } catch ($) {
      throw w && w(), $ && $.name === "TypeError" && /Load failed|fetch/i.test($.message) ? Object.assign(
        new E("Network Error", E.ERR_NETWORK, p, m),
        {
          cause: $.cause || $
        }
      ) : E.from($, $ && $.code, p, m);
    }
  });
}, Gr = /* @__PURE__ */ new Map(), Nn = (e) => {
  let t = e ? e.env : {};
  const { fetch: n, Request: s, Response: r } = t, i = [
    s,
    r,
    n
  ];
  let o = i.length, c = o, a, u, d = Gr;
  for (; c--; )
    a = i[c], u = d.get(a), u === void 0 && d.set(a, u = c ? /* @__PURE__ */ new Map() : Xr(t)), d = u;
  return u;
};
Nn();
const yt = {
  http: fr,
  xhr: Dr,
  fetch: {
    get: Nn
  }
};
l.forEach(yt, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch (n) {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Yt = (e) => `- ${e}`, Kr = (e) => l.isFunction(e) || e === null || e === !1, On = {
  getAdapter: (e, t) => {
    e = l.isArray(e) ? e : [e];
    const { length: n } = e;
    let s, r;
    const i = {};
    for (let o = 0; o < n; o++) {
      s = e[o];
      let c;
      if (r = s, !Kr(s) && (r = yt[(c = String(s)).toLowerCase()], r === void 0))
        throw new E(`Unknown adapter '${c}'`);
      if (r && (l.isFunction(r) || (r = r.get(t))))
        break;
      i[c || "#" + o] = r;
    }
    if (!r) {
      const o = Object.entries(i).map(
        ([a, u]) => `adapter ${a} ` + (u === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let c = n ? o.length > 1 ? `since :
` + o.map(Yt).join(`
`) : " " + Yt(o[0]) : "as no adapter specified";
      throw new E(
        "There is no suitable adapter to dispatch the request " + c,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: yt
};
function ht(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Ne(null, e);
}
function en(e) {
  return ht(e), e.headers = G.from(e.headers), e.data = ft.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), On.getAdapter(e.adapter || Me.adapter, e)(e).then(function(s) {
    return ht(e), s.data = ft.call(
      e,
      e.transformResponse,
      s
    ), s.headers = G.from(s.headers), s;
  }, function(s) {
    return Rn(s) || (ht(e), s && s.response && (s.response.data = ft.call(
      e,
      e.transformResponse,
      s.response
    ), s.response.headers = G.from(s.response.headers))), Promise.reject(s);
  });
}
const An = "1.12.2", rt = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  rt[e] = function(s) {
    return typeof s === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const tn = {};
rt.transitional = function(t, n, s) {
  function r(i, o) {
    return "[Axios v" + An + "] Transitional option '" + i + "'" + o + (s ? ". " + s : "");
  }
  return (i, o, c) => {
    if (t === !1)
      throw new E(
        r(o, " has been removed" + (n ? " in " + n : "")),
        E.ERR_DEPRECATED
      );
    return n && !tn[o] && (tn[o] = !0, console.warn(
      r(
        o,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(i, o, c) : !0;
  };
};
rt.spelling = function(t) {
  return (n, s) => (console.warn(`${s} is likely a misspelling of ${t}`), !0);
};
function Zr(e, t, n) {
  if (typeof e != "object")
    throw new E("options must be an object", E.ERR_BAD_OPTION_VALUE);
  const s = Object.keys(e);
  let r = s.length;
  for (; r-- > 0; ) {
    const i = s[r], o = t[i];
    if (o) {
      const c = e[i], a = c === void 0 || o(c, i, e);
      if (a !== !0)
        throw new E("option " + i + " must be " + a, E.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new E("Unknown option " + i, E.ERR_BAD_OPTION);
  }
}
const Ge = {
  assertOptions: Zr,
  validators: rt
}, ce = Ge.validators;
let _e = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new Ht(),
      response: new Ht()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(t, n) {
    return ae(this, null, function* () {
      try {
        return yield this._request(t, n);
      } catch (s) {
        if (s instanceof Error) {
          let r = {};
          Error.captureStackTrace ? Error.captureStackTrace(r) : r = new Error();
          const i = r.stack ? r.stack.replace(/^.+\n/, "") : "";
          try {
            s.stack ? i && !String(s.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (s.stack += `
` + i) : s.stack = i;
          } catch (o) {
          }
        }
        throw s;
      }
    });
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = je(this.defaults, n);
    const { transitional: s, paramsSerializer: r, headers: i } = n;
    s !== void 0 && Ge.assertOptions(s, {
      silentJSONParsing: ce.transitional(ce.boolean),
      forcedJSONParsing: ce.transitional(ce.boolean),
      clarifyTimeoutError: ce.transitional(ce.boolean)
    }, !1), r != null && (l.isFunction(r) ? n.paramsSerializer = {
      serialize: r
    } : Ge.assertOptions(r, {
      encode: ce.function,
      serialize: ce.function
    }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), Ge.assertOptions(n, {
      baseUrl: ce.spelling("baseURL"),
      withXsrfToken: ce.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = i && l.merge(
      i.common,
      i[n.method]
    );
    i && l.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (p) => {
        delete i[p];
      }
    ), n.headers = G.concat(o, i);
    const c = [];
    let a = !0;
    this.interceptors.request.forEach(function(_) {
      typeof _.runWhen == "function" && _.runWhen(n) === !1 || (a = a && _.synchronous, c.unshift(_.fulfilled, _.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(_) {
      u.push(_.fulfilled, _.rejected);
    });
    let d, x = 0, S;
    if (!a) {
      const p = [en.bind(this), void 0];
      for (p.unshift(...c), p.push(...u), S = p.length, d = Promise.resolve(n); x < S; )
        d = d.then(p[x++], p[x++]);
      return d;
    }
    S = c.length;
    let R = n;
    for (; x < S; ) {
      const p = c[x++], _ = c[x++];
      try {
        R = p(R);
      } catch (b) {
        _.call(this, b);
        break;
      }
    }
    try {
      d = en.call(this, R);
    } catch (p) {
      return Promise.reject(p);
    }
    for (x = 0, S = u.length; x < S; )
      d = d.then(u[x++], u[x++]);
    return d;
  }
  getUri(t) {
    t = je(this.defaults, t);
    const n = En(t.baseURL, t.url, t.allowAbsoluteUrls);
    return Sn(n, t.params, t.paramsSerializer);
  }
};
l.forEach(["delete", "get", "head", "options"], function(t) {
  _e.prototype[t] = function(n, s) {
    return this.request(je(s || {}, {
      method: t,
      url: n,
      data: (s || {}).data
    }));
  };
});
l.forEach(["post", "put", "patch"], function(t) {
  function n(s) {
    return function(i, o, c) {
      return this.request(je(c || {}, {
        method: t,
        headers: s ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: o
      }));
    };
  }
  _e.prototype[t] = n(), _e.prototype[t + "Form"] = n(!0);
});
let Qr = class Tn {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    const s = this;
    this.promise.then((r) => {
      if (!s._listeners) return;
      let i = s._listeners.length;
      for (; i-- > 0; )
        s._listeners[i](r);
      s._listeners = null;
    }), this.promise.then = (r) => {
      let i;
      const o = new Promise((c) => {
        s.subscribe(c), i = c;
      }).then(r);
      return o.cancel = function() {
        s.unsubscribe(i);
      }, o;
    }, t(function(i, o, c) {
      s.reason || (s.reason = new Ne(i, o, c), n(s.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (s) => {
      t.abort(s);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Tn(function(r) {
        t = r;
      }),
      cancel: t
    };
  }
};
function Yr(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function ei(e) {
  return l.isObject(e) && e.isAxiosError === !0;
}
const wt = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(wt).forEach(([e, t]) => {
  wt[t] = e;
});
function Pn(e) {
  const t = new _e(e), n = un(_e.prototype.request, t);
  return l.extend(n, _e.prototype, t, { allOwnKeys: !0 }), l.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(r) {
    return Pn(je(e, r));
  }, n;
}
const L = Pn(Me);
L.Axios = _e;
L.CanceledError = Ne;
L.CancelToken = Qr;
L.isCancel = Rn;
L.VERSION = An;
L.toFormData = st;
L.AxiosError = E;
L.Cancel = L.CanceledError;
L.all = function(t) {
  return Promise.all(t);
};
L.spread = Yr;
L.isAxiosError = ei;
L.mergeConfig = je;
L.AxiosHeaders = G;
L.formToJSON = (e) => Cn(l.isHTMLForm(e) ? new FormData(e) : e);
L.getAdapter = On.getAdapter;
L.HttpStatusCode = wt;
L.default = L;
const {
  Axios: pi,
  AxiosError: mi,
  CanceledError: xi,
  isCancel: bi,
  CancelToken: gi,
  VERSION: yi,
  all: wi,
  Cancel: _i,
  isAxiosError: ji,
  spread: Si,
  toFormData: ki,
  AxiosHeaders: Ci,
  HttpStatusCode: Ri,
  formToJSON: vi,
  getAdapter: Ei,
  mergeConfig: $i
} = L, ti = 1e3 * 5, ni = (n, ...s) => ae(null, [n, ...s], function* (e, t = {}) {
  var c, a, u;
  let r, i, o;
  try {
    const d = yield L({
      url: e,
      method: t.method,
      timeout: ti
    });
    i = d.data, o = d.status;
  } catch (d) {
    L.isAxiosError(d) ? (i = (c = d.response) == null ? void 0 : c.data, r = (a = d.response) == null ? void 0 : a.statusText, o = (u = d.response) == null ? void 0 : u.status) : r = d == null ? void 0 : d.message;
  }
  return {
    error: r,
    data: i,
    statusCode: o
  };
}), nn = () => ({
  get: (e, t = {}) => ni(e, V(T({}, t), {
    method: "GET"
  }))
}), si = [mt.groupType.BRAND, mt.groupType.CATEGORY], ri = "default";
function Ni({
  params: e = {},
  isStandaloneSite: t = !0,
  shouldLoad: n = !0,
  minTabs: s = 2,
  maxTabs: r = 9
}) {
  var I;
  const [i, o] = K([]), [c, a] = K(!0), [u, d] = K(!0), [x, S] = K(""), [R, p] = K([]), [_, b] = K(""), A = ee({}), v = ee(!1), k = R == null ? void 0 : R.find((H) => H.groupId === _), N = si.includes(`${(I = k == null ? void 0 : k.groupType) == null ? void 0 : I.toLowerCase()}`), F = (H, g) => {
    const y = V(T({}, H), {
      groupId: g
    });
    return t ? Ut.getRecoDataAndes(y) : Ut.getRecoDataNonAndes(y);
  };
  return le(() => {
    ae(null, null, function* () {
      if (v != null && v.current || !n)
        return;
      const g = yield nn().get(F(e, ri));
      if (g != null && g.error) {
        p([]), S(""), a(!1), d(!1), v.current = !0;
        return;
      }
      const {
        carouselName: y,
        groups: j,
        products: h
      } = Mt({
        data: g == null ? void 0 : g.data,
        isStandaloneSite: t,
        minTabs: s,
        maxTabs: r
      });
      if (j.length && h.length) {
        const m = j == null ? void 0 : j.find((w) => w == null ? void 0 : w.isDefault);
        if (m) {
          const w = m == null ? void 0 : m.groupId;
          A.current[w] = h, o(h), b(w);
        }
        S(y), p(j);
      }
      a(!1), d(!1), v.current = !0;
    });
  }, [n]), le(() => {
    ae(null, null, function* () {
      if (!n || !_)
        return;
      const g = A.current[_];
      if (g) {
        o(g), a(!1);
        return;
      }
      a(!0);
      const y = yield nn().get(F(e, _));
      if (y != null && y.error) {
        o([]), a(!1);
        return;
      }
      const {
        products: j
      } = Mt({
        data: y == null ? void 0 : y.data,
        isStandaloneSite: t,
        minTabs: s,
        maxTabs: r
      });
      A.current[_] = j, o(j), a(!1);
    });
  }, [_, n]), {
    selectedGroupId: _,
    selectedGroup: k,
    isLoading: c,
    isFirstLoad: u,
    showMore: N,
    onGroupSelect: (H) => {
      H !== _ && b(H);
    },
    carouselName: x,
    groups: R,
    products: i
  };
}
export {
  di as PillsButton,
  li as RecommendedProducts,
  ui as RecommendedProductsEmpty,
  li as default,
  Ni as useRecoProducts
};
